<template>
    <div class="payment">
        <div class="paymentSecure">
            <p class="paymentSecure_title">{{ translateWord('Método de pagamento seguro') }}</p>

            <div class="paymentSecure_stamps">
                <div class="paymentSecure_stamps_item">
                    <icon class="paymentSecure_stamps_item_icon" name="shield" />
                    <p class="paymentSecure_stamps_item_name">{{ translateWord('100% Seguro') }}</p>
                </div>

                <div class="paymentSecure_stamps_item">
                    <icon class="paymentSecure_stamps_item_icon" name="lock" />
                    <p class="paymentSecure_stamps_item_name">{{ translateWord('SSL Certificado') }}</p>
                </div>
            </div>
        </div>

        <!-- Metodos de Pagamento -->
        <div class="payment_paymentMethods">

            <!-- Google Pay, Apple Pay and Amazon Pay -->
            <div v-if="paymentMethodEnabled.googlePay" class="payment_paymentMethods_item_content payment_paymentMethods_itemWallet" @click.capture="paymentMethod('googlePay')">
                <p id="stripe-wallets-loading">Loading payment methods with digital wallet</p>
                <div id="stripe-wallets"></div>
            </div>

            <!-- myCards-->
            <div v-if="paymentMethodEnabled.myCards" class="payment_paymentMethods_item payment_paymentMethods_itemMyCards" :class="{paymentMethodsActive: paymentMethodSelected == 'myCards'}">
                <div class="payment_paymentMethods_item_menu" @click="paymentMethod('myCards')">
                    <div class="payment_paymentMethods_item_menu_data">
                        <div class="payment_paymentMethods_item_menu_data_symbol">
                            <span class="payment_paymentMethods_item_menu_data_symbol_ball"></span>
                        </div>
                        <img class="payment_paymentMethods_item_menu_data_img" src="../assets/my-cards.png">
                        <p class="payment_paymentMethods_item_menu_data_name">{{ translateWord('Meus Cartões') }}</p>
                    </div>

                    <div  v-if="paymentMethodSelected == 'myCards'" class="payment_paymentMethods_item_menu_info">{{ translateWord('Selecione abaixo seu cartão vinculado com a builderall para realizar a compra com apenas 1 click') }}</div>
                </div>

                <div v-if="paymentMethodSelected == 'myCards'" class="payment_paymentMethods_item_content">
                    <div 
                        v-for="(cardCredit, index) in myCards"
                        :key="index" 
                        class="payment_paymentMethods_item_myCards" 
                        :class="{payment_paymentMethods_item_myCardsActive: cardCredit.selected}"
                        @click="selectedMyCard(index)"
                    >
                        <div class="payment_paymentMethods_item_myCards_Number payment_paymentMethods_item_myCards_separete">
                            <div class="payment_paymentMethods_item_myCards_check"></div>
                            
                            <img v-if="!product.isTheCurrency.eur" class="payment_paymentMethods_item_myCards_brand" :src="require(`../assets/card-brands/${cardCredit.brand}.jpg`)" />

                            <p class="payment_paymentMethods_item_myCards_number">
                                **** **** **** {{ cardCredit.last_four_digits }} 
                            </p>

                            <div class="payment_paymentMethods_item_myCards_validate">
                                <span class="payment_paymentMethods_item_myCards_validate_year">{{ cardCredit.year }}-</span>
                                <span class="payment_paymentMethods_item_myCards_validate_month">{{ cardCredit.month }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 
        <template v-else-if="paymentMethodSelected == 'myCards'">
            <div class="payment_card_myCard">
                <div class="payment_card_myCard_imgs">
                    <img src="../assets/builderall-logo.png" alt="" class="payment_card_myCard_imgs_logo">
                    <img src="../assets/chip-card.png" alt="" class="payment_card_myCard_imgs_chip">
                </div>

                <div class="payment_card_myCard_info">
                    <p class="payment_card_myCard_info_number">
                        **** **** **** {{ myCardSelectedPayment.last_four_digit }}
                    </p>

                    <div>
                        <p class="payment_card_myCard_info_due">{{ myCardSelectedPayment.due_month }} / {{ myCardSelectedPayment.due_year }}</p>
                        <img :src="user.cards.brand_img" alt="" class="payment_card_myCard_info_brand">
                    </div>
                </div>
            </div>
        </template> -->

            <!-- Cartão de credito -->
            <div v-if="paymentMethodEnabled.creditCard" class="payment_paymentMethods_item payment_paymentMethods_itemCreditCard" :class="{paymentMethodsActive: paymentMethodSelected == 'creditCard'}">
                <div class="payment_paymentMethods_item_menu" @click="paymentMethod('creditCard')">
                    <div class="payment_paymentMethods_item_menu_data">
                        <div class="payment_paymentMethods_item_menu_data_symbol">
                            <span class="payment_paymentMethods_item_menu_data_symbol_ball"></span>
                        </div>

                        <img class="payment_paymentMethods_item_menu_data_img" src="../assets/credit-card.svg">
                        <p class="payment_paymentMethods_item_menu_data_name">{{ translateWord('Cartão de Credito') }}</p>
                    </div>

                    <div class="payment_paymentMethods_item_menu_info"></div>
                </div>

                <div v-if="paymentMethodSelected == 'creditCard'" class="payment_paymentMethods_item_content">
                    <div class="payment_paymentMethods_item_content_title">
                        <p>{{ translateWord('Adicionar detalhes de pagamento') }}</p>
                        <p>{{ translateWord('Por favor, insira seus detalhes de pagamento abaixo') }}</p>
                    </div>

                    <!-- Stripe -->
                    <template v-if="stripe.isVisible && paymentMethodSelected == 'creditCard'">
                        <form name="form-stripe">
                            <div class="col-xs-24 mandatory">
                                <at-input v-model="stripe.holderName" :status="stripe.fieldsValidators.holderName.error ? 'error' : ''" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Nome do titular do cartão')">
                                    <template slot="prepend">
                                        <span class="icon icon-user"></span>
                                    </template>
                                </at-input>
                                <span>*</span>
                            </div>

                            <div id="stripe-element"></div>
                        </form>
                    </template>

                    <!-- Pagar.me -->
                    <template v-if="pagarme.isVisible && paymentMethodSelected == 'creditCard'">
                        <form name="form-pagarme" class="row">
                            <div class="payment_card_name col-xs-24 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-model="pagarme.card.holderName" :status="fieldErrors.pagarme.card.holderName ? 'error' : ''" @focusout.native="fieldErrors.pagarme.card.holderName = validateFieldOnBlur('holderName', pagarme.card.holderName)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Nome do titular do cartão')">
                                </at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.pagarme.card.holderName">{{ fieldErrors.pagarme.card.holderName }}</span>
                            </div>

                            <div class="payment_card_number col-xs-24 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-mask="'#### #### #### ####'" v-model="pagarme.card.number" :status="fieldErrors.pagarme.card.number ? 'error' : ''" @focusout.native="fieldErrors.pagarme.card.number = validateFieldOnBlur('cardNumber', pagarme.card.number)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Numero do cartão')">
                                </at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.pagarme.card.number">{{ fieldErrors.pagarme.card.number }}</span>
                            </div>

                            <div class="payment_card_validate col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-mask="'##/####'" v-model="pagarme.card.validate" :status="fieldErrors.pagarme.card.validate ? 'error' : ''" @focusout.native="fieldErrors.pagarme.card.validate = validateFieldOnBlur('cardValidate', pagarme.card.validate)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Validade do cartão')">
                                </at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.pagarme.card.validate">{{ fieldErrors.pagarme.card.validate }}</span>
                            </div>

                            <div class="payment_card_cvc col-xs-12 col-sm-12 col-md-12 col-lg-12 mandatory">
                                <at-input v-mask="'####'" v-model="pagarme.card.cvc" :status="fieldErrors.pagarme.card.cvc ? 'error' : ''" @focusout.native="fieldErrors.pagarme.card.cvc = validateFieldOnBlur('cardCvc', pagarme.card.cvc)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CVV/CVC')">
                                </at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.pagarme.card.cvc">{{ fieldErrors.pagarme.card.cvc }}</span>
                            </div>
                        </form>

                        <p class="payment_paymentMethods_item_title">{{ translateWord('Informações adicionais') }}:</p>

                        <div class="row">
                            <div class="payment_card_phone col-xs-24 col-sm-12 col-md-12 col-lg-12 mandatory">
                                <at-input v-mask="['(##) ####-####', '(##) #####-####']" v-model="pagarme.card.phone.areaCodeAndNumber" :status="fieldErrors.pagarme.card.phone ? 'error' : ''" @focusout.native="fieldErrors.pagarme.card.phone = validateFieldOnBlur('phoneBr', pagarme.card.phone.areaCodeAndNumber)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Telefone')">
                                </at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.pagarme.card.phone">{{ fieldErrors.pagarme.card.phone }}</span>
                            </div>
                            <div class="payment_card_cpf col-xs-24 col-sm-12 col-md-12 col-lg-12 mandatory">
                                <at-input v-mask="['###.###.###-##', '##.###.###/####-##']" v-model="pagarme.card.cpfOrCnpj" :status="fieldErrors.pagarme.card.cpfOrCnpj ? 'error' : ''" @focusout.native="fieldErrors.pagarme.card.cpfOrCnpj = validateFieldOnBlur('cpfOrCnpj', pagarme.card.cpfOrCnpj)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CPF ou CNPJ')">
                                </at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.pagarme.card.cpfOrCnpj">{{ fieldErrors.pagarme.card.cpfOrCnpj }}</span>
                            </div>
                        </div>

                        <div v-if="['EUR', 'BRL'].includes(product.currency) && ['creditCard', 'sepa', 'boleto'].includes(paymentMethodSelected) && !this.isFirstPaymentUpLine" class="payment_paymentMethods_item_address">
                            <p class="payment_paymentMethods_item_title">{{ translateWord('Endereço') }}:</p>

                            <div class="row">
                                <div class="payment_address_postalCode col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                    <template v-if="product.currency == 'BRL'">
                                        <at-input v-mask="['#########']" v-model="address.zipCode" :status="fieldErrors.address.zipCode ? 'error' : ''" @focusout.native="fieldErrors.address.zipCode = validateFieldOnBlur('required', address.zipCode)" @blur="searchLocaleZipCode" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CEP')"></at-input>
                                    </template>
                                    <template v-else>
                                        <at-input v-model="address.zipCode" :status="fieldErrors.address.zipCode ? 'error' : ''" @focusout.native="fieldErrors.address.zipCode = validateFieldOnBlur('required', address.zipCode)" @blur="searchLocaleZipCode" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CEP')"></at-input>
                                    </template>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.address.zipCode">{{ fieldErrors.address.zipCode }}</span>
                                </div>
                                <div class="payment_address_country col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory" v-if="product.currency == 'EUR'">
                                    <at-input v-model="address.country" :status="fieldErrors.address.country ? 'error' : ''" @focusout.native="fieldErrors.address.country = validateFieldOnBlur('required', address.country)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('País')"></at-input>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.address.country">{{ fieldErrors.address.country }}</span>
                                </div>
                                <div class="payment_address_country col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory" v-if="product.currency == 'BRL'">
                                    <at-input maxlength="4" v-model="address.stateCode" :status="fieldErrors.address.stateCode ? 'error' : ''" @focusout.native="fieldErrors.address.stateCode = validateFieldOnBlur('required', address.stateCode)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Estado')"></at-input>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.address.stateCode">{{ fieldErrors.address.stateCode }}</span>
                                </div>
                                <div class="payment_address_city col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                    <at-input v-model="address.city" :status="fieldErrors.address.city ? 'error' : ''" @focusout.native="fieldErrors.address.city = validateFieldOnBlur('required', address.city)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Cidade')"></at-input>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.address.city">{{ fieldErrors.address.city }}</span>
                                </div>
                                <div class="payment_address_district col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory" v-if="product.currency == 'BRL'">
                                    <at-input v-model="address.district" :status="fieldErrors.address.district ? 'error' : ''" @focusout.native="fieldErrors.address.district = validateFieldOnBlur('required', address.district)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Bairro')"></at-input>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.address.district">{{ fieldErrors.address.district }}</span>
                                </div>
                                <div class="payment_address_addressCompleted mandatory" :class="[product.currency == 'BRL' ? 'col-xs-12 col-sm-12 col-md-12  col-lg-16' : 'col-xs-12 col-sm-12 col-md-12  col-lg-12']">
                                    <at-input v-model="address.street" :status="fieldErrors.address.street ? 'error' : ''" @focusout.native="fieldErrors.address.street = validateFieldOnBlur('required', address.street)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Rua')"></at-input>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.address.street">{{ fieldErrors.address.street }}</span>
                                </div>
                                <div class="payment_address_country col-xs-12 col-sm-12 col-md-12  col-lg-8 mandatory" v-if="product.currency == 'BRL'">
                                    <at-input v-model="address.number" :status="fieldErrors.address.number ? 'error' : ''" @focusout.native="fieldErrors.address.number = validateFieldOnBlur('required', address.number)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Numero')"></at-input>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.address.number">{{ fieldErrors.address.number }}</span>
                                </div>
                                <div class="payment_address_country col-xs-24 col-sm-12 col-md-12  col-lg-12" v-if="product.currency == 'BRL'">
                                    <at-input v-model="address.complement" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Complemento')"></at-input>
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- Adyen -->
                    <template v-if="adyen.isVisible && paymentMethodSelected == 'creditCard'">
                        <form name="form-adyen" class="row">
                            <div class="payment_card_name col-xs-24 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-model="adyen.card.holderName" :status="fieldErrors.adyen.card.holderName ? 'error' : ''" @focusout.native="fieldErrors.adyen.card.holderName = validateFieldOnBlur('holderName', adyen.card.holderName)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Nome do titular do cartão')">
                                </at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.adyen.card.holderName">{{ fieldErrors.adyen.card.holderName }}</span>
                            </div>

                            <div class="payment_card_number col-xs-24 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-mask="'#### #### #### ####'" v-model="adyen.card.number" :status="fieldErrors.adyen.card.number ? 'error' : ''" @focusout.native="fieldErrors.adyen.card.number = validateFieldOnBlur('cardNumber', adyen.card.number)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Numero do cartão')">
                                </at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.adyen.card.number">{{ fieldErrors.adyen.card.number }}</span>
                            </div>

                            <div class="payment_card_validate col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-mask="'##/##'" v-model="adyen.validate" :status="fieldErrors.adyen.card.validate ? 'error' : ''" @focusout.native="fieldErrors.adyen.card.validate = validateFieldOnBlur('cardValidate', adyen.validate)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Validade do cartão')">
                                </at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.adyen.card.validate">{{ fieldErrors.adyen.card.validate }}</span>
                            </div>

                            <div class="payment_card_cvc col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-mask="'####'" v-model="adyen.card.cvc" :status="fieldErrors.adyen.card.cvc ? 'error' : ''" @focusout.native="fieldErrors.adyen.card.cvc = validateFieldOnBlur('cardCvc', adyen.card.cvc)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CVV/CVC')">
                                </at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.adyen.card.cvc">{{ fieldErrors.adyen.card.cvc }}</span>
                            </div>
                        </form>

                        <form method="POST" :action="adyen.threeDS.issuerUrl" style="display: none;">
                            <input type="hidden" name="PaReq" :value="adyen.threeDS.paRequest" />
                            <input type="hidden" name="MD" :value="adyen.threeDS.md" />
                            <input type="hidden" name="TermUrl" :value="adyen.threeDS.termUrl" />

                            <input type="submit" class="button" value="enviar" ref="threeDSAdyen"/>
                        </form>

                        <div v-if="['EUR'].includes(product.currency) && ['creditCard', 'sepa'].includes(paymentMethodSelected) && !this.isFirstPaymentUpLine" class="payment_paymentMethods_item_address">
                            <p class="payment_paymentMethods_item_title">{{ translateWord('Endereço') }}:</p>

                            <div class="row">
                                <div class="payment_address_postalCode col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                    <at-input v-model="address.zipCode" :status="fieldErrors.address.zipCode ? 'error' : ''" @focusout.native="fieldErrors.address.zipCode = validateFieldOnBlur('required', address.zipCode)" @blur="searchLocaleZipCode" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CEP')"></at-input>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.address.zipCode">{{ fieldErrors.address.zipCode }}</span>
                                </div>
                                <div class="payment_address_country col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                    <at-input v-model="address.country" :status="fieldErrors.address.country ? 'error' : ''" @focusout.native="fieldErrors.address.country = validateFieldOnBlur('required', address.country)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('País')"></at-input>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.address.country">{{ fieldErrors.address.country }}</span>
                                </div>
                                <div class="payment_address_city col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                    <at-input v-model="address.city" :status="fieldErrors.address.city ? 'error' : ''" @focusout.native="fieldErrors.address.city = validateFieldOnBlur('required', address.city)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Cidade')"></at-input>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.address.city">{{ fieldErrors.address.city }}</span>
                                </div>
                                <div class="payment_address_addressCompleted col-xs-12 col-sm-12 col-md-12 col-lg-12 mandatory">
                                    <at-input v-model="address.street" :status="fieldErrors.address.street ? 'error' : ''" @focusout.native="fieldErrors.address.street = validateFieldOnBlur('required', address.street)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Rua')"></at-input>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.address.street">{{ fieldErrors.address.street }}</span>
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- Payu -->
                    <template v-if="payu.isVisibleCreditCard && paymentMethodSelected == 'creditCard'">
                        <form name="form-pagarme" class="row">
                            <div class="payment_card_name col-xs-24 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-model="payu.card.holderName" :status="fieldErrors.payu.card.holderName ? 'error' : ''" @focusout.native="fieldErrors.payu.card.holderName = validateFieldOnBlur('holderName', payu.card.holderName)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Nome do titular do cartão')">
                                </at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.payu.card.holderName">{{ fieldErrors.payu.card.holderName }}</span>
                            </div>

                            <div class="payment_card_number col-xs-24 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-mask="'#### #### #### ####'" v-model="payu.card.number" :status="fieldErrors.payu.card.number ? 'error' : ''" @focusout.native="fieldErrors.payu.card.number = validateFieldOnBlur('cardNumber', payu.card.number)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Numero do cartão')">
                                </at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.payu.card.number">{{ fieldErrors.payu.card.number }}</span>
                            </div>

                            <div class="payment_card_validate col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-mask="['#/##', '##/##', '#/####', '##/####']" v-model="payu.card.validate" :status="fieldErrors.payu.card.validate ? 'error' : ''" @focusout.native="fieldErrors.payu.card.validate = validateFieldOnBlur('cardValidate', payu.card.validate)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Validade do cartão')">
                                </at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.payu.card.validate">{{ fieldErrors.payu.card.validate }}</span>
                            </div>

                            <div class="payment_card_cvc col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-mask="'####'" v-model="payu.card.cvc" :status="fieldErrors.payu.card.cvc ? 'error' : ''" @focusout.native="fieldErrors.payu.card.cvc = validateFieldOnBlur('cardCvc', payu.card.cvc)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CVV/CVC')">
                                </at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.payu.card.cvc">{{ fieldErrors.payu.card.cvc }}</span>
                            </div>
                        </form>

                        <p class="payment_paymentMethods_item_title">{{ translateWord('Informações adicionais') }}:</p>

                        <div class="row">
                            <div class="payment_card_cpf col-xs-24 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <template v-if="product.currency == 'BRL'">
                                    <at-input v-mask="['###.###.###-##', '##.###.###/####-##']" v-model="payu.card.dni" :status="fieldErrors.payu.card.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.card.dni = validateFieldOnBlur('dni', payu.card.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CPF ou CNPJ')"></at-input>
                                </template>
                                <template v-else-if="product.currency == 'PEN'">
                                    <at-input v-mask="'########'" v-model="payu.card.dni" :status="fieldErrors.payu.card.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.card.dni = validateFieldOnBlur('dni', payu.card.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('DNI')"></at-input>
                                </template>
                                <template v-else-if="product.currency == 'ARS'">
                                    <at-input v-mask="['#######', '########', '##-########-#']" v-model="payu.card.dni" :status="fieldErrors.payu.card.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.card.dni = validateFieldOnBlur('dni', payu.card.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('DNI / CUIT')"></at-input>
                                </template>
                                <template v-else-if="product.currency == 'COP'">
                                    <at-input v-mask="['######', '#######', '########', '#########', '##########']" v-model="payu.card.dni" :status="fieldErrors.payu.card.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.card.dni = validateFieldOnBlur('dni', payu.card.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CC')"></at-input>
                                </template>
                                <template v-else-if="product.currency == 'MXN'">
                                    <at-input v-model="payu.card.dni" :status="fieldErrors.payu.card.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.card.dni = validateFieldOnBlur('dni', payu.card.dni)" @keyup.native="verifyActiveContinueStep()" size="large" maxlength="18" :placeholder="translateWord('CURP / RFC')"></at-input>
                                </template>
                                <template v-else>
                                    <at-input v-model="payu.card.dni" :status="fieldErrors.payu.card.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.card.dni = validateFieldOnBlur('dni', payu.card.dni)" @keyup.native="verifyActiveContinueStep()" size="large" maxlength="20" :placeholder="translateWord('Documento Dni')"></at-input>
                                </template>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.payu.card.dni">{{ fieldErrors.payu.card.dni }}</span>
                            </div>

                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mandatory">
                                <vue-tel-input :inputOptions="{placeholder: translateWord('Seu Telefone')}" @input="changePhone" @blur="fieldErrors.payu.card.phone = validateFieldOnBlur('phone', payu.card.phone.fullNumber)" style="padding: 0px;">
                                    <span slot="arrow-icon"><<</span>
                                </vue-tel-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.payu.card.phone">{{ fieldErrors.payu.card.phone }}</span>
                            </div>
                            
                            <!-- <div class="payment_card_cpf col-xs-24 col-sm-12 col-md-12  col-lg-12">
                                <at-input v-mask="['###.###.###-##', '##.###.###/####-##']" v-model="pagarme.card.cpfOrCnpj" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CPF ou CNPJ')">
                                </at-input>
                            </div> -->
                        </div>

                        <div v-if="!this.isFirstPaymentUpLine" class="payment_paymentMethods_item_address">
                            <p class="payment_paymentMethods_item_title">{{ translateWord('Endereço') }}:</p>

                            <div class="row">
                                <div class="payment_address_postalCode col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                    <template v-if="product.currency == 'BRL'">
                                        <at-input v-mask="['#########']" v-model="address.zipCode" :status="fieldErrors.address.zipCode ? 'error' : ''" @focusout.native="fieldErrors.address.zipCode = validateFieldOnBlur('required', address.zipCode)" @blur="searchLocaleZipCode" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CEP')"></at-input>
                                    </template>
                                    <template v-else>
                                        <at-input v-model="address.zipCode" :status="fieldErrors.address.zipCode ? 'error' : ''" @focusout.native="fieldErrors.address.zipCode = validateFieldOnBlur('required', address.zipCode)" @blur="searchLocaleZipCode" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CEP')"></at-input>
                                    </template>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.address.zipCode">{{ fieldErrors.address.zipCode }}</span>
                                </div>
                                <div class="payment_address_country col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory" v-if="product.currency == 'BRL'">
                                    <at-input maxlength="4" v-model="address.stateCode" :status="fieldErrors.address.stateCode ? 'error' : ''" @focusout.native="fieldErrors.address.stateCode = validateFieldOnBlur('required', address.stateCode)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Estado')"></at-input>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.address.stateCode">{{ fieldErrors.address.stateCode }}</span>
                                </div>
                                <div class="payment_address_city col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                    <at-input v-model="address.city" :status="fieldErrors.address.city ? 'error' : ''" @focusout.native="fieldErrors.address.city = validateFieldOnBlur('required', address.city)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Cidade')"></at-input>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.address.city">{{ fieldErrors.address.city }}</span>
                                </div>
                                <div class="payment_address_addressCompleted mandatory" :class="[product.currency == 'BRL' ? 'col-xs-12 col-sm-12 col-md-12  col-lg-16' : 'col-xs-12 col-sm-12 col-md-12  col-lg-12']">
                                    <at-input v-model="address.street" :status="fieldErrors.address.street ? 'error' : ''" @focusout.native="fieldErrors.address.street = validateFieldOnBlur('required', address.street)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Rua')"></at-input>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.address.street">{{ fieldErrors.address.street }}</span>
                                </div>
                            </div>
                        </div>
                    </template>

                    <div class="payment_paymentMethods_itemCreditCard_brands">
                        <img class="payment_paymentMethods_itemCreditCard_brands_image" src="../assets/card-brands/visa.jpg" alt="Visa" title="Visa">
                        <img class="payment_paymentMethods_itemCreditCard_brands_image" src="../assets/card-brands/mastercard.jpg" alt="Master Card" title="Master Card">
                        <img class="payment_paymentMethods_itemCreditCard_brands_image" src="../assets/card-brands/american_express.jpg" alt="American Express" title="American Express">
                        <img class="payment_paymentMethods_itemCreditCard_brands_image" src="../assets/card-brands/discover.jpg" alt="Discover" title="Discover">
                        <img class="payment_paymentMethods_itemCreditCard_brands_image" src="../assets/card-brands/diners_club.jpg" alt="Diners Club" title="Diners Club">
                    </div>
                </div>
            </div>

            <!-- Pix -->
            <div v-if="paymentMethodEnabled.pix" class="payment_paymentMethods_item payment_paymentMethods_itemPix" :class="{paymentMethodsActive: paymentMethodSelected == 'pix'}">
                <div class="payment_paymentMethods_item_menu" @click="paymentMethod('pix')">
                    <div class="payment_paymentMethods_item_menu_data">
                        <div class="payment_paymentMethods_item_menu_data_symbol">
                            <span class="payment_paymentMethods_item_menu_data_symbol_ball"></span>
                        </div>
                        <img class="payment_paymentMethods_item_menu_data_img" src="../assets/pix.png">
                        <p class="payment_paymentMethods_item_menu_data_name">{{ translateWord('Pix') }}</p>
                    </div>

                    <div class="payment_paymentMethods_item_menu_info" v-if="paymentMethodSelected == 'pix'">
                        <p>Para gerar o PIX de pagamento, preencha os dados abaixo. Em seguida, basta clicar no botão de gerar PIX.</p>
                    </div>
                </div>

                <div v-if="paymentMethodSelected == 'pix'" class="payment_paymentMethods_item_content">
                    <div class="row">
                        <div class="payment_card_phone col-xs-24 col-sm-12 col-md-12  col-lg-12 mandatory">
                            <at-input v-mask="['(##) ####-####', '(##) #####-####']" v-model="pagarme.card.phone.areaCodeAndNumber" :status="fieldErrors.pix.phone ? 'error' : ''" @focusout.native="fieldErrors.pix.phone = validateFieldOnBlur('phoneBr', pagarme.card.phone.areaCodeAndNumber)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Telefone')">
                            </at-input>
                            <span>*</span>
                            <span class="field-error" v-if="fieldErrors.pix.phone">{{ fieldErrors.pix.phone }}</span>
                        </div>
                        <div class="payment_card_cpf col-xs-24 col-sm-12 col-md-12  col-lg-12 mandatory">
                            <at-input v-mask="['###.###.###-##', '##.###.###/####-##']" v-model="pagarme.card.cpfOrCnpj" :status="fieldErrors.pix.cpfOrCnpj ? 'error' : ''" @focusout.native="fieldErrors.pix.cpfOrCnpj = validateFieldOnBlur('cpfOrCnpj', pagarme.card.cpfOrCnpj)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CPF ou CNPJ')">
                            </at-input>
                            <span>*</span>
                            <span class="field-error" v-if="fieldErrors.pix.cpfOrCnpj">{{ fieldErrors.pix.cpfOrCnpj }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Boleto -->
            <div v-if="paymentMethodEnabled.boleto"  class="payment_paymentMethods_item" :class="{paymentMethodsActive: paymentMethodSelected == 'boleto'}">
                <div class="payment_paymentMethods_item_menu" @click="paymentMethod('boleto')">
                    <div class="payment_paymentMethods_item_menu_data">
                        <div class="payment_paymentMethods_item_menu_data_symbol">
                            <span class="payment_paymentMethods_item_menu_data_symbol_ball"></span>
                        </div>
                        <img class="payment_paymentMethods_item_menu_data_img" src="../assets/boleto.svg">
                        <p class="payment_paymentMethods_item_menu_data_name">{{ translateWord('Boleto') }}</p>
                    </div>

                    <div class="payment_paymentMethods_item_menu_info" v-if="paymentMethodSelected == 'boleto'">
                        <p>{{ translateWord('Para gerar seu boleto de pagamento, preencha os dados abaixo. Em seguida basta clicar no botão gerar boleto') }}</p>
                    </div>
                </div>

                <div v-if="paymentMethodSelected == 'boleto'" class="payment_paymentMethods_item_content payment_paymentMethods_item_contentBoleto">
                    <p class="payment_paymentMethods_item_title">{{ translateWord('Informações adicionais') }}:</p>

                    <div class="row">
                        <div class="payment_card_phone col-xs-24 col-sm-12 col-md-12  col-lg-12 mandatory">
                            <vue-tel-input :inputOptions="{placeholder: translateWord('Seu Telefone')}" @input="onBoletoPhoneInput" @blur="fieldErrors.boleto.phone = validateFieldOnBlur('phone', payu.boleto.phone ? payu.boleto.phone.fullNumber || '' : '')">
                                <span slot="arrow-icon"><<</span>
                            </vue-tel-input>
                            <span>*</span>
                            <span class="field-error" v-if="fieldErrors.boleto.phone">{{ fieldErrors.boleto.phone }}</span>
                        </div>
                        <div class="payment_card_cpf col-xs-24 col-sm-12 col-md-12  col-lg-12 mandatory">
                            <at-input v-mask="['###.###.###-##', '##.###.###/####-##']" v-model="payu.boleto.cpfOrCnpj" :status="fieldErrors.boleto.cpfOrCnpj ? 'error' : ''" @focusout.native="fieldErrors.boleto.cpfOrCnpj = validateFieldOnBlur('cpfOrCnpj', payu.boleto.cpfOrCnpj)" @keyup.native="boletoFieldsTouched = true; verifyActiveContinueStep()" size="large" :placeholder="translateWord('CPF ou CNPJ')">
                            </at-input>
                            <span>*</span>
                            <span class="field-error" v-if="fieldErrors.boleto.cpfOrCnpj">{{ fieldErrors.boleto.cpfOrCnpj }}</span>
                        </div>
                    </div>

                    <div class="payment_paymentMethods_item_address">
                        <p class="payment_paymentMethods_item_title">{{ translateWord('Endereço') }}:</p>

                        <div class="row">
                            <div class="payment_address_postalCode col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <template v-if="product.currency == 'BRL'">
                                    <at-input v-mask="['#########']" v-model="address.zipCode" :status="fieldErrors.address.zipCode ? 'error' : ''" @focusout.native="fieldErrors.address.zipCode = validateFieldOnBlur('required', address.zipCode)" @blur="searchLocaleZipCode" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CEP')"></at-input>
                                </template>
                                <template v-else>
                                    <at-input v-model="address.zipCode" :status="fieldErrors.address.zipCode ? 'error' : ''" @focusout.native="fieldErrors.address.zipCode = validateFieldOnBlur('required', address.zipCode)" @blur="searchLocaleZipCode" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CEP')"></at-input>
                                </template>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.zipCode">{{ fieldErrors.address.zipCode }}</span>
                            </div>
                            <div class="payment_address_country col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory" v-if="product.currency == 'EUR'">
                                <at-input v-model="address.country" :status="fieldErrors.address.country ? 'error' : ''" @focusout.native="fieldErrors.address.country = validateFieldOnBlur('required', address.country)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('País')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.country">{{ fieldErrors.address.country }}</span>
                            </div>
                            <div class="payment_address_country col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory" v-if="product.currency == 'BRL'">
                                <at-input maxlength="4" v-model="address.stateCode" :status="fieldErrors.address.stateCode ? 'error' : ''" @focusout.native="fieldErrors.address.stateCode = validateFieldOnBlur('required', address.stateCode)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Estado')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.stateCode">{{ fieldErrors.address.stateCode }}</span>
                            </div>
                            <div class="payment_address_city col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-model="address.city" :status="fieldErrors.address.city ? 'error' : ''" @focusout.native="fieldErrors.address.city = validateFieldOnBlur('required', address.city)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Cidade')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.city">{{ fieldErrors.address.city }}</span>
                            </div>
                            <div class="payment_address_district col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory" v-if="product.currency == 'BRL'">
                                <at-input v-model="address.district" :status="fieldErrors.address.district ? 'error' : ''" @focusout.native="fieldErrors.address.district = validateFieldOnBlur('required', address.district)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Bairro')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.district">{{ fieldErrors.address.district }}</span>
                            </div>
                            <div class="payment_address_addressCompleted mandatory" :class="[product.currency == 'BRL' ? 'col-xs-12 col-sm-12 col-md-12  col-lg-16' : 'col-xs-12 col-sm-12 col-md-12  col-lg-12']">
                                <at-input v-model="address.street" :status="fieldErrors.address.street ? 'error' : ''" @focusout.native="fieldErrors.address.street = validateFieldOnBlur('required', address.street)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Rua')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.street">{{ fieldErrors.address.street }}</span>
                            </div>
                            <div class="payment_address_country col-xs-12 col-sm-12 col-md-12 col-lg-8 mandatory" v-if="product.currency == 'BRL'">
                                <at-input v-model="address.number" :status="fieldErrors.address.number ? 'error' : ''" @focusout.native="fieldErrors.address.number = validateFieldOnBlur('required', address.number)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Numero')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.number">{{ fieldErrors.address.number }}</span>
                            </div>
                            <div class="payment_address_country col-xs-24 col-sm-12 col-md-12  col-lg-12" v-if="product.currency == 'BRL'">
                                <at-input v-model="address.complement" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Complemento')"></at-input>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Cash -->
            <div v-if="paymentMethodEnabled.cash"  class="payment_paymentMethods_item" :class="{paymentMethodsActive: paymentMethodSelected == 'cash'}">
                <div class="payment_paymentMethods_item_menu" @click="paymentMethod('cash')">
                    <div class="payment_paymentMethods_item_menu_data">
                        <div class="payment_paymentMethods_item_menu_data_symbol">
                            <span class="payment_paymentMethods_item_menu_data_symbol_ball"></span>
                        </div>
                        <img class="payment_paymentMethods_item_menu_data_img" src="../assets/boleto.svg">
                        <p class="payment_paymentMethods_item_menu_data_name">Cash</p>
                    </div>

                    <div class="payment_paymentMethods_item_menu_info" v-if="paymentMethodSelected == 'cash'">
                        <p>{{ translateWord('Para gerar seu cash de pagamento, preencha os dados abaixo. Em seguida basta clicar no botão gerar cash') }}</p>
                    </div>
                </div>

                <div v-if="paymentMethodSelected == 'cash'" class="payment_paymentMethods_item_content">
                    <p class="payment_paymentMethods_item_title">{{ translateWord('Informações adicionais') }}:</p>

                    <div class="row">
                        <div class="payment_card_cpf col-xs-24 col-sm-12 col-md-12  col-lg-12 mandatory">
                            <template v-if="product.currency == 'BRL'">
                                <at-input v-mask="['###.###.###-##', '##.###.###/####-##']" v-model="payu.cash.dni" :status="fieldErrors.payu.cash.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.cash.dni = validateFieldOnBlur('dni', payu.cash.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CPF ou CNPJ')"></at-input>
                            </template>
                            <template v-else-if="product.currency == 'PEN'">
                                <at-input v-mask="'########'" v-model="payu.cash.dni" :status="fieldErrors.payu.cash.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.cash.dni = validateFieldOnBlur('dni', payu.cash.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('DNI')"></at-input>
                            </template>
                            <template v-else-if="product.currency == 'ARS'">
                                <at-input v-mask="['#######', '########', '##-########-#']" v-model="payu.cash.dni" :status="fieldErrors.payu.cash.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.cash.dni = validateFieldOnBlur('dni', payu.cash.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('DNI / CUIT')"></at-input>
                            </template>
                            <template v-else-if="product.currency == 'COP'">
                                <at-input v-mask="['######', '#######', '########', '#########', '##########']" v-model="payu.cash.dni" :status="fieldErrors.payu.cash.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.cash.dni = validateFieldOnBlur('dni', payu.cash.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CC')"></at-input>
                            </template>
                            <template v-else-if="product.currency == 'MXN'">
                                <at-input v-model="payu.cash.dni" :status="fieldErrors.payu.cash.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.cash.dni = validateFieldOnBlur('dni', payu.cash.dni)" @keyup.native="verifyActiveContinueStep()" size="large" maxlength="18" :placeholder="translateWord('CURP / RFC')"></at-input>
                            </template>
                            <template v-else>
                                <at-input v-model="payu.cash.dni" :status="fieldErrors.payu.cash.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.cash.dni = validateFieldOnBlur('dni', payu.cash.dni)" @keyup.native="verifyActiveContinueStep()" size="large" maxlength="20" :placeholder="translateWord('Documento Dni')"></at-input>
                            </template>
                            <span>*</span>
                            <span class="field-error" v-if="fieldErrors.payu.cash.dni">{{ fieldErrors.payu.cash.dni }}</span>
                        </div>
                    </div>

                    <div class="payment_paymentMethods_item_address">
                        <p class="payment_paymentMethods_item_title">{{ translateWord('Endereço') }}:</p>

                        <div class="row">
                            <div class="payment_address_country col-xs-24 col-sm-24 col-md-24  col-lg-24 mandatory">
                                <at-input v-model="address.street" :status="fieldErrors.address.street ? 'error' : ''" @focusout.native="fieldErrors.address.street = validateFieldOnBlur('required', address.street)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Endereço')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.street">{{ fieldErrors.address.street }}</span>
                            </div>
                            <div class="payment_address_city col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-model="address.city" :status="fieldErrors.address.city ? 'error' : ''" @focusout.native="fieldErrors.address.city = validateFieldOnBlur('required', address.city)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Cidade')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.city">{{ fieldErrors.address.city }}</span>
                            </div>
                            <div class="payment_address_district col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-mask="['AA']" v-model="address.stateCode" :status="fieldErrors.address.stateCode ? 'error' : ''" @focusout.native="fieldErrors.address.stateCode = validateFieldOnBlur('required', address.stateCode)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Estado')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.stateCode">{{ fieldErrors.address.stateCode }}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Bank Transfer -->
            <div v-if="paymentMethodEnabled.bankTransfer"  class="payment_paymentMethods_item" :class="{paymentMethodsActive: paymentMethodSelected == 'bankTransfer'}">
                <div class="payment_paymentMethods_item_menu" @click="paymentMethod('bankTransfer')">
                    <div class="payment_paymentMethods_item_menu_data">
                        <div class="payment_paymentMethods_item_menu_data_symbol">
                            <span class="payment_paymentMethods_item_menu_data_symbol_ball"></span>
                        </div>
                        <img class="payment_paymentMethods_item_menu_data_img" src="../assets/imagem/bank-transfer.png">
                        <p class="payment_paymentMethods_item_menu_data_name">{{ translateWord('Bank Transfer') }} </p>
                    </div>

                    <div class="payment_paymentMethods_item_menu_info" v-if="paymentMethodSelected == 'bankTransfer'">
                        <p>{{ translateWord('Para gerar seu bank transfer, preencha os dados abaixo. Em seguida basta clicar no botão gerar bank transfer') }}</p>
                    </div>
                </div>

                <div v-if="paymentMethodSelected == 'bankTransfer'" class="payment_paymentMethods_item_content payment_paymentMethods_item_contentBankTransfer">
                    <p class="payment_paymentMethods_item_title">{{ translateWord('Informações adicionais') }}:</p>

                    <div class="row">
                        <div class="col-xs-24 col-sm-24 col-md-24 col-lg-24">
                            <div class="row">
                                <div class="col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                    <template v-if="product.currency == 'BRL'">
                                        <at-input v-mask="['###.###.###-##', '##.###.###/####-##']" v-model="payu.bankTransfer.dni" :status="fieldErrors.payu.bankTransfer.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.bankTransfer.dni = validateFieldOnBlur('dni', payu.bankTransfer.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CPF ou CNPJ')"></at-input>
                                    </template>
                                    <template v-else-if="product.currency == 'PEN'">
                                        <at-input v-mask="'########'" v-model="payu.bankTransfer.dni" :status="fieldErrors.payu.bankTransfer.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.bankTransfer.dni = validateFieldOnBlur('dni', payu.bankTransfer.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('DNI')"></at-input>
                                    </template>
                                    <template v-else-if="product.currency == 'ARS'">
                                        <at-input v-mask="['#######', '########', '##-########-#']" v-model="payu.bankTransfer.dni" :status="fieldErrors.payu.bankTransfer.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.bankTransfer.dni = validateFieldOnBlur('dni', payu.bankTransfer.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('DNI / CUIT')"></at-input>
                                    </template>
                                    <template v-else-if="product.currency == 'COP'">
                                        <at-input v-mask="['######', '#######', '########', '#########', '##########']" v-model="payu.bankTransfer.dni" :status="fieldErrors.payu.bankTransfer.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.bankTransfer.dni = validateFieldOnBlur('dni', payu.bankTransfer.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CC')"></at-input>
                                    </template>
                                    <template v-else-if="product.currency == 'MXN'">
                                        <at-input v-model="payu.bankTransfer.dni" :status="fieldErrors.payu.bankTransfer.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.bankTransfer.dni = validateFieldOnBlur('dni', payu.bankTransfer.dni)" @keyup.native="verifyActiveContinueStep()" size="large" maxlength="18" :placeholder="translateWord('CURP / RFC')"></at-input>
                                    </template>
                                    <template v-else>
                                        <at-input v-model="payu.bankTransfer.dni" :status="fieldErrors.payu.bankTransfer.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.bankTransfer.dni = validateFieldOnBlur('dni', payu.bankTransfer.dni)" @keyup.native="verifyActiveContinueStep()" size="large" maxlength="20" :placeholder="translateWord('Documento Dni')"></at-input>
                                    </template>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.payu.bankTransfer.dni">{{ fieldErrors.payu.bankTransfer.dni }}</span>
                                </div>

                                <template v-if="product.currency == 'COP'">
                                    <div class="col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                        <at-input v-model="payu.bankTransfer.email" :status="fieldErrors.payu.bankTransfer.email ? 'error' : ''" @focusout.native="fieldErrors.payu.bankTransfer.email = validateFieldOnBlur('email', payu.bankTransfer.email)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('E-mail')"></at-input>
                                        <span>*</span>
                                        <span class="field-error" v-if="fieldErrors.payu.bankTransfer.email">{{ fieldErrors.payu.bankTransfer.email }}</span>
                                    </div>

                                </template>
                            </div>
                        </div>

                        <template v-if="product.currency == 'COP'">
                            <div class="col-xs-24 col-sm-24 col-md-24 col-lg-24 mandatory">
                                <at-select :placeholder="translateWord('Selecionar Banco')" v-model="payu.bankTransfer.bankSelected" @change="fieldErrors.payu.bankTransfer.bankSelected = ''; verifyActiveContinueStep()" @focusout.native="fieldErrors.payu.bankTransfer.bankSelected = !payu.bankTransfer.bankSelected ? translateWord('Campo obrigatório') : ''">
                                    <at-option v-for="bank in payu.bankTransfer.listBanks" :value="bank.pseCode">{{ bank.description }}</at-option>
                                </at-select>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.payu.bankTransfer.bankSelected">{{ fieldErrors.payu.bankTransfer.bankSelected }}</span>
                            </div>

                            <div class="col-xs-24 col-sm-24 col-md-24 col-lg-24 mandatory">
                                <at-select :placeholder="translateWord('Tipo de pessoa')" v-model="payu.bankTransfer.personTypeSelected" @change="fieldErrors.payu.bankTransfer.personTypeSelected = ''; verifyActiveContinueStep()" @focusout.native="fieldErrors.payu.bankTransfer.personTypeSelected = !payu.bankTransfer.personTypeSelected ? translateWord('Campo obrigatório') : ''">
                                    <at-option value="N">{{ translateWord('Natural') }}</at-option>
                                    <at-option value="J">{{ translateWord('Legal') }}</at-option>
                                </at-select>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.payu.bankTransfer.personTypeSelected">{{ fieldErrors.payu.bankTransfer.personTypeSelected }}</span>
                            </div>

                            <div class="col-xs-24 col-sm-24 col-md-24 col-lg-24 mandatory">
                                <at-select :placeholder="translateWord('Identificação')" v-model="payu.bankTransfer.identificationSelected" @change="fieldErrors.payu.bankTransfer.identificationSelected = ''; verifyActiveContinueStep()" @focusout.native="fieldErrors.payu.bankTransfer.identificationSelected = !payu.bankTransfer.identificationSelected ? translateWord('Campo obrigatório') : ''">
                                    <at-option value="CC">{{ translateWord('Cédula de Cidadania') }}</at-option>
                                    <at-option value="CE">{{ translateWord('Cédula de Estrangeiro') }}</at-option>
                                    <at-option value="NIT">{{ translateWord('Número de Identificação Tributária') }}</at-option>
                                    <at-option value="TI">{{ translateWord('Carteira de Identidade') }}</at-option>
                                    <at-option value="PP">{{ translateWord('Passaporte') }}</at-option>
                                    <at-option value="RC">{{ translateWord('Certidão de Nascimento') }}</at-option>
                                    <at-option value="DE">{{ translateWord('Documento de Identificação Estrangeiro') }}</at-option>
                                </at-select>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.payu.bankTransfer.identificationSelected">{{ fieldErrors.payu.bankTransfer.identificationSelected }}</span>
                            </div>

                            <div class="col-xs-24 col-sm-24 col-md-24 col-lg-24">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mandatory">
                                        <at-input v-model="payu.bankTransfer.identification" :status="fieldErrors.payu.bankTransfer.identification ? 'error' : ''" @focusout.native="fieldErrors.payu.bankTransfer.identification = validateFieldOnBlur('required', payu.bankTransfer.identification)" @keyup.native="verifyActiveContinueStep()" size="large" maxlength="20" :placeholder="translateWord('Numero de identificação')"></at-input>
                                        <span>*</span>
                                        <span class="field-error" v-if="fieldErrors.payu.bankTransfer.identification">{{ fieldErrors.payu.bankTransfer.identification }}</span>
                                    </div>

                                    <div class="col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                        <vue-tel-input :inputOptions="{placeholder: translateWord('Seu Telefone')}" @input="changePhone" @blur="fieldErrors.payu.bankTransfer.phone = validateFieldOnBlur('phone', payu.bankTransfer.phone.fullNumber)">
                                            <span slot="arrow-icon"><<</span>
                                        </vue-tel-input>
                                        <span>*</span>
                                        <span class="field-error" v-if="fieldErrors.payu.bankTransfer.phone">{{ fieldErrors.payu.bankTransfer.phone }}</span>
                                    </div>
                                </div>
                            </div>

                           
                        </template>
                    </div>

                    <div class="payment_paymentMethods_item_address">
                        <p class="payment_paymentMethods_item_title">{{ translateWord('Endereço') }}:</p>

                        <div class="row">
                            <div class="payment_address_country col-xs-24 col-sm-24 col-md-24  col-lg-24 mandatory">
                                <at-input v-model="address.street" :status="fieldErrors.address.street ? 'error' : ''" @focusout.native="fieldErrors.address.street = validateFieldOnBlur('required', address.street)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Endereço')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.street">{{ fieldErrors.address.street }}</span>
                            </div>
                            <div class="payment_address_city col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-model="address.city" :status="fieldErrors.address.city ? 'error' : ''" @focusout.native="fieldErrors.address.city = validateFieldOnBlur('required', address.city)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Cidade')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.city">{{ fieldErrors.address.city }}</span>
                            </div>
                            <div class="payment_address_district col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-mask="['AA']" v-model="address.stateCode" :status="fieldErrors.address.stateCode ? 'error' : ''" @focusout.native="fieldErrors.address.stateCode = validateFieldOnBlur('required', address.stateCode)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Estado')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.stateCode">{{ fieldErrors.address.stateCode }}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Nequi -->
            <div v-if="paymentMethodEnabled.nequi"  class="payment_paymentMethods_item" :class="{paymentMethodsActive: paymentMethodSelected == 'nequi'}">
                <div class="payment_paymentMethods_item_menu" @click="paymentMethod('nequi')">
                    <div class="payment_paymentMethods_item_menu_data">
                        <div class="payment_paymentMethods_item_menu_data_symbol">
                            <span class="payment_paymentMethods_item_menu_data_symbol_ball"></span>
                        </div>
                        <img class="payment_paymentMethods_item_menu_data_img" src="../assets/imagem/nequi.png">
                        <p class="payment_paymentMethods_item_menu_data_name">Nequi</p>
                    </div>

                    <div class="payment_paymentMethods_item_menu_info" v-if="paymentMethodSelected == 'nequi'">
                        <p>{{ translateWord('Para gerar seu pagamento, preencha os dados abaixo. Em seguida basta clicar no botão gerar com nequi') }}</p>
                    </div>
                </div>

                <div v-if="paymentMethodSelected == 'nequi'" class="payment_paymentMethods_item_content payment_paymentMethods_item_contentNequi">
                    <p class="payment_paymentMethods_item_title">{{ translateWord('Informações adicionais') }}:</p>

                    <div class="row">
                        <div class="col-xs-24 col-sm-24 col-md-24 col-lg-24">
                            <div class="mandatory">
                                <at-input v-model="payu.nequi.email" :status="fieldErrors.payu.nequi.email ? 'error' : ''" @focusout.native="fieldErrors.payu.nequi.email = validateFieldOnBlur('email', payu.nequi.email)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('E-mail')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.payu.nequi.email">{{ fieldErrors.payu.nequi.email }}</span>
                            </div>
                        </div>

                        <div class="payment_card_cpf col-xs-24 col-sm-12 col-md-12  col-lg-12">
                            <div class="mandatory">
                                <template v-if="product.currency == 'BRL'">
                                    <at-input v-mask="['###.###.###-##', '##.###.###/####-##']" v-model="payu.nequi.dni" :status="fieldErrors.payu.nequi.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.nequi.dni = validateFieldOnBlur('dni', payu.nequi.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CPF ou CNPJ')"></at-input>
                                </template>
                                <template v-else-if="product.currency == 'PEN'">
                                    <at-input v-mask="'########'" v-model="payu.nequi.dni" :status="fieldErrors.payu.nequi.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.nequi.dni = validateFieldOnBlur('dni', payu.nequi.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('DNI')"></at-input>
                                </template>
                                <template v-else-if="product.currency == 'ARS'">
                                    <at-input v-mask="['#######', '########', '##-########-#']" v-model="payu.nequi.dni" :status="fieldErrors.payu.nequi.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.nequi.dni = validateFieldOnBlur('dni', payu.nequi.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('DNI / CUIT')"></at-input>
                                </template>
                                <template v-else-if="product.currency == 'COP'">
                                    <at-input v-mask="['######', '#######', '########', '#########', '##########']" v-model="payu.nequi.dni" :status="fieldErrors.payu.nequi.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.nequi.dni = validateFieldOnBlur('dni', payu.nequi.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CC')"></at-input>
                                </template>
                                <template v-else-if="product.currency == 'MXN'">
                                    <at-input v-model="payu.nequi.dni" :status="fieldErrors.payu.nequi.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.nequi.dni = validateFieldOnBlur('dni', payu.nequi.dni)" @keyup.native="verifyActiveContinueStep()" size="large" maxlength="18" :placeholder="translateWord('CURP / RFC')"></at-input>
                                </template>
                                <template v-else>
                                    <at-input v-model="payu.nequi.dni" :status="fieldErrors.payu.nequi.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.nequi.dni = validateFieldOnBlur('dni', payu.nequi.dni)" @keyup.native="verifyActiveContinueStep()" size="large" maxlength="20" :placeholder="translateWord('Documento Dni')"></at-input>
                                </template>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.payu.nequi.dni">{{ fieldErrors.payu.nequi.dni }}</span>
                            </div>
                        </div>

                        <div class="col-xs-24 col-sm-12 col-md-12  col-lg-12">
                            <div class="mandatory">
                                <vue-tel-input :inputOptions="{placeholder: translateWord('Seu Telefone')}" @input="changePhone" @blur="fieldErrors.payu.nequi.phone = validateFieldOnBlur('phone', payu.nequi.phone.fullNumber)">
                                    <span slot="arrow-icon"><<</span>
                                </vue-tel-input>

                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.payu.nequi.phone">{{ fieldErrors.payu.nequi.phone }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="payment_paymentMethods_item_address">
                        <p class="payment_paymentMethods_item_title">{{ translateWord('Endereço') }}:</p>

                        <div class="row">
                            <div class="payment_address_country col-xs-24 col-sm-24 col-md-24  col-lg-24 mandatory">
                                <at-input v-model="address.street" :status="fieldErrors.address.street ? 'error' : ''" @focusout.native="fieldErrors.address.street = validateFieldOnBlur('required', address.street)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Endereço')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.street">{{ fieldErrors.address.street }}</span>
                            </div>
                            <div class="payment_address_city col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-model="address.city" :status="fieldErrors.address.city ? 'error' : ''" @focusout.native="fieldErrors.address.city = validateFieldOnBlur('required', address.city)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Cidade')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.city">{{ fieldErrors.address.city }}</span>
                            </div>
                            <div class="payment_address_district col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-mask="['AA']" v-model="address.stateCode" :status="fieldErrors.address.stateCode ? 'error' : ''" @focusout.native="fieldErrors.address.stateCode = validateFieldOnBlur('required', address.stateCode)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Estado')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.stateCode">{{ fieldErrors.address.stateCode }}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Yape -->
            <div v-if="paymentMethodEnabled.yape"  class="payment_paymentMethods_item" :class="{paymentMethodsActive: paymentMethodSelected == 'yape'}">
                <div class="payment_paymentMethods_item_menu" @click="paymentMethod('yape')">
                    <div class="payment_paymentMethods_item_menu_data">
                        <div class="payment_paymentMethods_item_menu_data_symbol">
                            <span class="payment_paymentMethods_item_menu_data_symbol_ball"></span>
                        </div>
                        <img class="payment_paymentMethods_item_menu_data_img" src="../assets/imagem/yape.png">
                        <p class="payment_paymentMethods_item_menu_data_name">Yape</p>
                    </div>

                    <div class="payment_paymentMethods_item_menu_info" v-if="paymentMethodSelected == 'yape'">
                        <p>{{ translateWord('Para gerar seu pagamento, preencha os dados abaixo. Em seguida basta clicar no botão pagar com Yape') }}</p>
                    </div>
                </div>

                <div v-if="paymentMethodSelected == 'yape'" class="payment_paymentMethods_item_content payment_paymentMethods_item_contentNequi">
                    <p class="payment_paymentMethods_item_title">{{ translateWord('Informações adicionais') }}:</p>

                    <div class="row">
                        <div class="col-xs-24 col-sm-24 col-md-24 col-lg-24">
                            <div class="mandatory">
                                <at-input v-model="payu.yape.email" :status="fieldErrors.payu.yape.email ? 'error' : ''" @focusout.native="fieldErrors.payu.yape.email = validateFieldOnBlur('email', payu.yape.email)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('E-mail')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.payu.yape.email">{{ fieldErrors.payu.yape.email }}</span>
                            </div>
                        </div>

                        <div class="payment_card_cpf col-xs-24 col-sm-12 col-md-12  col-lg-12">
                            <div class="mandatory">
                                <template v-if="product.currency == 'BRL'">
                                    <at-input v-mask="['###.###.###-##', '##.###.###/####-##']" v-model="payu.yape.dni" :status="fieldErrors.payu.yape.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.yape.dni = validateFieldOnBlur('dni', payu.yape.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CPF ou CNPJ')"></at-input>
                                </template>
                                <template v-else-if="product.currency == 'PEN'">
                                    <at-input v-mask="'########'" v-model="payu.yape.dni" :status="fieldErrors.payu.yape.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.yape.dni = validateFieldOnBlur('dni', payu.yape.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('DNI')"></at-input>
                                </template>
                                <template v-else-if="product.currency == 'ARS'">
                                    <at-input v-mask="['#######', '########', '##-########-#']" v-model="payu.yape.dni" :status="fieldErrors.payu.yape.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.yape.dni = validateFieldOnBlur('dni', payu.yape.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('DNI / CUIT')"></at-input>
                                </template>
                                <template v-else-if="product.currency == 'COP'">
                                    <at-input v-mask="['######', '#######', '########', '#########', '##########']" v-model="payu.yape.dni" :status="fieldErrors.payu.yape.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.yape.dni = validateFieldOnBlur('dni', payu.yape.dni)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('CC')"></at-input>
                                </template>
                                <template v-else-if="product.currency == 'MXN'">
                                    <at-input v-model="payu.yape.dni" :status="fieldErrors.payu.yape.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.yape.dni = validateFieldOnBlur('dni', payu.yape.dni)" @keyup.native="verifyActiveContinueStep()" size="large" maxlength="18" :placeholder="translateWord('CURP / RFC')"></at-input>
                                </template>
                                <template v-else>
                                    <at-input v-model="payu.yape.dni" :status="fieldErrors.payu.yape.dni ? 'error' : ''" @focusout.native="fieldErrors.payu.yape.dni = validateFieldOnBlur('dni', payu.yape.dni)" @keyup.native="verifyActiveContinueStep()" size="large" maxlength="20" :placeholder="translateWord('Documento Dni')"></at-input>
                                </template>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.payu.yape.dni">{{ fieldErrors.payu.yape.dni }}</span>
                            </div>
                        </div>

                        <div class="col-xs-24 col-sm-12 col-md-12  col-lg-12">
                            <div class="mandatory">
                                <vue-tel-input :inputOptions="{placeholder: translateWord('Seu Telefone')}" @input="changePhone" @blur="fieldErrors.payu.yape.phone = validateFieldOnBlur('phone', payu.yape.phone.fullNumber)">
                                    <span slot="arrow-icon"><<</span>
                                </vue-tel-input>

                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.payu.yape.phone">{{ fieldErrors.payu.yape.phone }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="payment_paymentMethods_item_yapeCode">
                        <p class="payment_paymentMethods_item_title">{{ translateWord('Codigo gerado pelo aplicativo Yape') }}:</p>

                        <div class="row">
                            <div class="payment_address_country col-xs-24 col-sm-24 col-md-24  col-lg-24">
                                <div class="mandatory">
                                    <at-input v-model="payu.yape.code" v-mask="'######'" :status="fieldErrors.payu.yape.code ? 'error' : ''" @focusout.native="fieldErrors.payu.yape.code = validateFieldOnBlur('yapeCode', payu.yape.code)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Codigo Yape')"></at-input>
                                    <span>*</span>
                                    <span class="field-error" v-if="fieldErrors.payu.yape.code">{{ fieldErrors.payu.yape.code }}</span>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="payment_paymentMethods_item_address">
                        <p class="payment_paymentMethods_item_title">{{ translateWord('Endereço') }}:</p>

                        <div class="row">
                            <div class="payment_address_country col-xs-24 col-sm-24 col-md-24  col-lg-24 mandatory">
                                <at-input v-model="address.street" :status="fieldErrors.address.street ? 'error' : ''" @focusout.native="fieldErrors.address.street = validateFieldOnBlur('required', address.street)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Endereço')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.street">{{ fieldErrors.address.street }}</span>
                            </div>
                            <div class="payment_address_city col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-model="address.city" :status="fieldErrors.address.city ? 'error' : ''" @focusout.native="fieldErrors.address.city = validateFieldOnBlur('required', address.city)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Cidade')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.city">{{ fieldErrors.address.city }}</span>
                            </div>
                            <div class="payment_address_district col-xs-12 col-sm-12 col-md-12  col-lg-12 mandatory">
                                <at-input v-mask="['AA']" v-model="address.stateCode" :status="fieldErrors.address.stateCode ? 'error' : ''" @focusout.native="fieldErrors.address.stateCode = validateFieldOnBlur('required', address.stateCode)" @keyup.native="verifyActiveContinueStep()" size="large" :placeholder="translateWord('Estado')"></at-input>
                                <span>*</span>
                                <span class="field-error" v-if="fieldErrors.address.stateCode">{{ fieldErrors.address.stateCode }}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Paypal -->
            <div v-if="paymentMethodEnabled.paypal" class="payment_paymentMethods_item payment_paymentMethods_itemPaypal" :class="{paymentMethodsActive: paymentMethodSelected == 'paypal'}">
                <div class="payment_paymentMethods_item_menu" @click="paymentMethod('paypal')">
                    <div class="payment_paymentMethods_item_menu_data">
                        <div class="payment_paymentMethods_item_menu_data_symbol">
                            <span class="payment_paymentMethods_item_menu_data_symbol_ball"></span>
                        </div>
                        <img class="payment_paymentMethods_item_menu_data_img" src="../assets/paypal.png">
                        <p class="payment_paymentMethods_item_menu_data_name">{{ translateWord('Paypal') }}</p>
                    </div>

                    <div class="payment_paymentMethods_item_menu_info"></div>
                </div>

                <div v-if="paymentMethodSelected == 'paypal'" class="payment_paymentMethods_item_content">
                    <!--<template v-if="isPaymentCountryPrice">{{ translateWord('Pagamento por Country Price, somente em USD.') }}</template>
                    <template v-else>{{ translateWord('Clicando no botão abaixo, você será redirecionado para o site do paypal, para concluir sua compra com segurança') }}</template>-->
                    {{ translateWord('Clicando no botão abaixo, você será redirecionado para o site do paypal, para concluir sua compra com segurança') }}
                </div>
            </div>

            <!-- PagSeguro -->
            <div v-if="paymentMethodEnabled.pagSeguro" class="payment_paymentMethods_item payment_paymentMethods_itemPagseguro" :class="{paymentMethodsActive: paymentMethodSelected == 'pagSeguro'}">
                <div class="payment_paymentMethods_item_menu" @click="paymentMethod('pagSeguro')">
                    <div class="payment_paymentMethods_item_menu_data">
                        <div class="payment_paymentMethods_item_menu_data_symbol">
                            <span class="payment_paymentMethods_item_menu_data_symbol_ball"></span>
                        </div>
                        <img class="payment_paymentMethods_item_menu_data_img" src="../assets/pagseguro-logo.png">
                        <p class="payment_paymentMethods_item_menu_data_name">PagSeguro</p>
                    </div>

                    <div class="payment_paymentMethods_item_menu_info"></div>
                </div>

                <div v-if="paymentMethodSelected == 'pagSeguro'" class="payment_paymentMethods_item_content">
                    Conteudo
                </div>
            </div>
        </div>

        <div v-if="paymentMethodSelected != 'googlePay'" class="payment_actions">
            <at-button @click="btnContinue" class="btn_formWidth" type="primary" :disabled="disabledBtnContinue">
                <span v-if="paymentMethodSelected == 'boleto'">{{ translateWord('Gerar boleto') }}</span>
                <span v-else-if="paymentMethodSelected == 'cash'">{{ translateWord('Gerar Cash') }}</span>
                <span v-else-if="paymentMethodSelected == 'bankTransfer'">{{ translateWord('Gerar Bank Transfer') }}</span>
                <span v-else-if="paymentMethodSelected == 'nequi'">{{ translateWord('Gerar com Nequi') }}</span>
                <span v-else-if="paymentMethodSelected == 'yape'">{{ translateWord('Pagar com Yape') }}</span>
                <span v-else-if="paymentMethodSelected == 'pix'">Gerar PIX</span>
                <span v-else-if="paymentMethodSelected == 'paypal'">
                    <!--<template v-if="isPaymentCountryPrice">{{ translateWord('Ir para plano USD') }}</template>
                    <template v-else>{{ translateWord('Ir para paypal') }}</template>-->
                    <template>{{ translateWord('Ir para paypal') }}</template>
                </span>
                <span v-else>{{ translateWord('Finalizar pagamento') }}</span>
            </at-button>

            <at-button v-if="devMode" @click="nextStepWithEmit" class="payment_actions_devModePaymentConfirmation" type="primary">
                <span>Ir para pagamento finalizado</span>
            </at-button>
        </div>
    </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'; 
import axios from 'axios';

import PixelAnalytics from '../assets/js/PixelAnalytics';
import bankListColombia from '../assets/js/bankListColombia';

import Box from '../components/Box';
import Helper from '../assets/js/helper';
import TempRedirPlan from '../assets/js/TempRedirPlan';

import { cpf as CpfVerifier, cnpj as CnpjVerifier } from 'cpf-cnpj-validator';
import cardValidator from 'card-validator';

import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
    name: "Payment",
    inject: ['prevStep','nextStep'],
    data(){
        return {
            responseBuilderallGateway: null,
            responseBuilderallGatewayFuturePayment: null,
            disabledBtnContinue: true,
            boletoFieldsTouched: false,
            isSendEventAddPaymentInfo: false,
            isCheckCouponFixedValue: false,
            couponAddUser: '',
            myCards: [],
            pagarme: {
                isVisible: false,
                tokenCard: '',
                card: {
                    number: '',
                    holderName: '',
                    expiryMonth: '',
                    expiryYear: '',
                    cvc: '',
                    validate: '',
                    cpfOrCnpj: '',
                    phone: {
                        areaCodeAndNumber: '',
                        areaCode: '',
                        number: ''
                    }
                },
            },
            stripe: {
                isVisible: false,
                instance: null,
                instanceWallet: null,
                elements: null,
                elementsWallet: null,
                card: null,
                tokenCard: null,
                holderName: '',
                setupIntent: null,
                cardSetup: null,
                sourceToken: null,
                fieldsValidators: {
                    holderName: {
                        error: false,
                        test: false
                    }
                }
            },
            adyen: {
                isVisible: false,
                isThreeSecureUrl: this.$route.query.hasOwnProperty('threeSecure'),
                threeSecureIdentify: this.$route.query.hasOwnProperty('threeSecure') ? this.$route.query.identify : false,
                isPaymentThreeSecure: localStorage.getItem('vatFee') && localStorage.getItem('localeUser'),
                card: {
                    number: '',
                    holderName: '',
                    expiryMonth: '',
                    expiryYear: '',
                    cvc: '',
                    generationtime: new Date().toJSON()
                },
                sepa: {
                    ownerName: '',
                    ibanNumber: '',
                    fieldsValidators: {
                        ownerName: {
                            error: false,
                            test: false
                        },
                        ibanNumber: {
                            error: false,
                            test: false
                        }
                    }
                },
                validate: '',
                cardAdyenEncrypt: null,
                fieldsValidators: {
                    number: {
                        error: false,
                        test: false
                    },
                    holderName: {
                        error: false,
                        test: false
                    },
                    validate: {
                        error: false,
                        test: false
                    },
                    cvc: {
                        error: false,
                        test: false
                    }
                },
                threeDS:{
                    issuerUrl: '',
                    md: '',
                    paRequest: '',
                    termUrl: ''
                }
            },
            payu: {
                isVisible: false,
                isVisibleCreditCard: false,
                card: {
                    dni: '',
                    phone: {
                        fullNumber: '',
                        areaCode: '',
                        number: ''
                    },
                    number: '',
                    holderName: '',
                    validate: '',
                    cvc: ''
                },
                cash: {
                    dni: '',
                    phone: ''
                },
                nequi: {
                    dni: '',
                    email: '',
                    phone: {
                        fullNumber: '',
                        areaCode: '',
                        number: ''
                    }
                },
                yape: {
                    dni: '',
                    code: '',
                    email: '',
                    phone: {
                        fullNumber: '',
                        areaCode: '',
                        number: ''
                    }
                },
                bankTransfer: {
                    dni: '',
                    phone: '',
                    bank: '',
                    listBanks: bankListColombia,
                    bankSelected: '',
                    personTypeSelected: '',
                    identificationSelected: '',
                    identification: '',
                    email: '',
                    phone: {
                        fullNumber: '',
                        areaCode: '',
                        number: ''
                    }
                },
                boleto: {
                    cnpfOrCnpj: '',
                    phone: {
                        fullNumber: '',
                        areaCode: '',
                        number: ''
                    }
                }
            },
            fieldErrors: {
                payu: {
                    card: { holderName: '', number: '', validate: '', cvc: '', dni: '', phone: '' },
                    cash: { dni: '' },
                    bankTransfer: { dni: '', identification: '', email: '', phone: '', bankSelected: '', personTypeSelected: '', identificationSelected: '' },
                    nequi: { dni: '', phone: '', email: '' },
                    yape: { dni: '', code: '', phone: '', email: '' }
                },
                adyen: {
                    card: { holderName: '', number: '', validate: '', cvc: '' }
                },
                pagarme: {
                    card: { holderName: '', number: '', validate: '', cvc: '', phone: '', cpfOrCnpj: '' }
                },
                pix: { phone: '', cpfOrCnpj: '' },
                boleto: { phone: '', cpfOrCnpj: '' },
                address: { zipCode: '', country: '', stateCode: '', city: '', district: '', street: '', number: '' }
            },
            address: {
                zipCode: '',
                city: '',
                street: '',
                country: '',
                stateCode: '',
                district: '',
                number: '',
                complement: '',
                fieldsValidators: {
                    zipCode: {
                        error: false,
                        test: false
                    },
                    city: {
                        error: false,
                        test: false
                    },
                    street: {
                        error: false,
                        test: false
                    },
                    country: {
                        error: false,
                        test: false
                    }
                }
            }
        }
    },
    computed: {
        ...mapState([
            'user',
            'userFather',
            'localeUser',
            'endpointGateway',
            'endpointOffice',
            'coupon',
            'fatura',
            'invoicePlanToActive',
            'vatFee',
            'adyenKeys',
            'totalPossibleFraud',
            'paymentMethodSelected',
            'paymentMethodEnabled',
            'isPlan',
            'fakeAmountPlanOrFee',
            'isPaymentOnlyPaypal',
            'isFirstPaymentUpLine',
            'isUserFatherToReceiveByGateway',
            'isPaymentDomain',
            'isPaymentStorage',
            'isPaymentDomainExtraConnection',
            'isPaymentCountryPrice',
            'planCountryPrice',
            'myCardSelectedPayment',
            'stepAction',
            'isChargedAmount',
            'isPauseAccount',
            'devMode',
            'bumpsell',
            'tokenCheckout'
        ]),
        ...mapGetters([
            'product',
            'hasCoupon',
            'hasCouponAndIsValid',
            'urlOfficeUser',
            'translateWord',
            'reasonCouponInvalid',
            'isPlanToActive',
            'getSlug',
            'isCoupon100Percent',
            'isCouponPeriodTime',
            'productAmount',
            'hasBumpsellAndSelected',
            'hasUpwork'
        ]),
        couponFormatAmount(){
            return Helper.calcDiscount(this.product.amount, this.coupon.value, this.coupon.type)
        },
        amountDiscount(){
            return parseFloat(parseFloat(this.product.amount - this.couponFormatAmount) + parseFloat(this.vatFee.amount)).toFixed(2)
        },
        amountFirstMonth(){
            let amountPlusVat = parseFloat(this.product.amountFirstMonth);
            
            if(this.vatFee.percentage > 0){
                return ((amountPlusVat * this.vatFee.percentage / 100) + amountPlusVat).toFixed(2);
            }
            
            return amountPlusVat.toFixed(2);
        }
    },
    watch: {
        'adyen.validate': function(value){
            if(value.length == 5){
                let year = (new Date()).getFullYear().toString();

                this.adyen.card.expiryMonth = value.substr(0, 2);
                this.adyen.card.expiryYear = `${year.substr(0,2)}${value.substr(3, 4)}`;
            }
        },
        'pagarme.card.validate': function(value){
            if(value.length == 7){
                this.pagarme.card.expiryMonth = value.substr(0, 2);
                this.pagarme.card.expiryYear = value.substr(3, 4);
            }
        },
        'pagarme.card.phone.areaCodeAndNumber': function(value){
            if(value.length >= 2){
                value = value.replace(/\D/gi, '');

                this.pagarme.card.phone.areaCode = value.substr(0, 2);
                this.pagarme.card.phone.number = value.substr(2);
            }
        },
        stepAction: function(value){
            if(value == 'prev') this.prevStepWithEmit();

            this.changeStepAction(true);
        },
        productAmount: function(newValue){
            // Atualiza o valor do Stripe Wallet quando o período muda (mensal/anual)
            if(this.stripe.elementsWallet){
                this.stripe.elementsWallet.update({
                    amount: Math.round(newValue * 100)
                });
            }
        }
    },
    async created(){
        if(['dev', 'test'].includes(Helper.getEnvs().env)){
            // this.adyen.card.number = '4111111111111111'; //4917610000000000 - 4111111111111111
            // this.adyen.card.holderName = 'John Smith';
            // this.adyen.validate = '03/30';
            // this.adyen.card.cvc = '737';
            
            // this.adyen.sepa.ownerName = 'B. Klaassen';
            // this.adyen.sepa.ibanNumber = 'NL36TEST0236169114';

            // this.pagarme.card.number = '4000000000000028';
            // this.pagarme.card.holderName = 'Philipinho Gomes';
            // this.pagarme.card.validate = '01/2030';
            // this.pagarme.card.cvc = '737';
            // this.pagarme.card.phone.areaCodeAndNumber = '31999999999';
            // this.pagarme.card.cpfOrCnpj = '18839195092';

            // this.payu.card.number = '4097440000000004';
            // this.payu.card.holderName = 'Philipinho Gomes';
            // this.payu.card.validate = '01/2026';
            // this.payu.card.cvc = '777';
            // this.payu.card.phone.fullNumber = '31999999999';
            // this.payu.card.dni = '56571916N';

            // this.payu.cash.dni = '56571916N';
            // this.payu.nequi.dni = '56571916N';
            // this.payu.bankTransfer.dni = '56571916N';
            // this.payu.yape.dni = '56571916N';

            // this.payu.bankTransfer.bankSelected = '1022';
            // this.payu.bankTransfer.personTypeSelected = 'N';
            // this.payu.bankTransfer.identificationSelected = 'CC';
            // this.payu.bankTransfer.identification = '123456789';

            // this.payu.yape.code = '557454';

            
            // if(this.product.currency == 'BRL'){
            //     this.address.zipCode = '31565220';
            //     this.searchLocaleZipCode();
            // }

            console.group('Lista de cartões');
            console.info('Requer autenticação apenas uma vez (SCA): 4000 0025 0000 3155');
            console.info('Requer autenticação forte na recorrencia (SCA): 4000 0027 6000 3184');
            console.log('Sem autenticação: 4111 1111 1111 1111');
            console.log('Sem autenticação: 4242 4242 4242 4242');
            console.groupEnd();
        }

        this.verifyCurrentPlanUser();

        if(this.user.isLogged){
            let typeRedir = Helper.redirUserPlanTrialOrPromotional(this.getSlug, this.user, this.userFather);

            if(typeRedir == 'tempRedir') return window.location.href = TempRedirPlan.getUrlRedir();
            if(typeRedir == 'office') return window.location.href = this.urlOfficeUser;

            if(this.user.credit_cards.length != 0){
                this.myCards = [];
                this.myCards = [...this.user.credit_cards];
                this.myCards = this.myCards.map(card => ({...card, selected: false}));

                this.myCards[0].selected = true;
            }

            this.payu.bankTransfer.email = this.user.email;
            this.payu.nequi.email = this.user.email;
            this.payu.yape.email = this.user.email;
        }

        if(this.paymentMethodEnabled.googlePay){
            this.mountedStripeWallet();
            this.paymentMethod('googlePay');
        }else{
            this.paymentMethod(this.paymentMethodSelected);
        }
        

        this.isCheckCouponFixedValue = true;

        this.verifyActiveContinueStep();
        
        PixelAnalytics.addDataLayer('StepPayment', {
            name: this.product.title,
            currency: this.product.currency,
            amount: this.product.amountCoupon ? this.product.amountCoupon : this.product.amount
        });

        this.userFatherToReceiveByGateway(false);

        PixelAnalytics.addDataLayer('SecondStep');

        if(PixelAnalytics.pixelEnabled.facebookPixel){
            PixelAnalytics.createEventPixel('fb', 'SecondStep');
        }

        if(PixelAnalytics.pixelEnabled.googleAnalytics){
            PixelAnalytics.createEventPixel('ga', null, {
                hitType: 'event',
                location: location.href,
                page: location.pathname,
                eventCategory: 'SecondStep'
            });
        }
        
        if(this.hasCoupon) this.couponAddUser = this.coupon.code;

        if(this.hasCouponAndIsValid && this.product.isTrialDays) this.enabledPaypal(false);

        if(this.isCoupon100Percent || this.isCouponPeriodTime){
            this.enabledPaypal(false);
            this.enabledBoleto(false);
        }

        this.addNoteVatFee();

        //Verifica se é o retorno da Adyen com pagamento 3D Secure
        if(this.adyen.isThreeSecureUrl && this.adyen.threeSecureIdentify && this.adyen.isPaymentThreeSecure){
            this.enabledFullScreenLoading({
                status: true,
                text: this.translateWord('Verificação final para finalizar o pagamento')
            });

            this.addAllData({
                stateName: 'localeUser',
                data: JSON.parse(localStorage.getItem('localeUser'))
            });

            this.addAllData({
                stateName: 'vatFee',
                data: JSON.parse(localStorage.getItem('vatFee'))
            });

            localStorage.removeItem('vatFee');
            localStorage.removeItem('localeUser');

            this.finalizePaymentAdyen();
        }
    },
    methods: {
        ...mapMutations([
            'enabledFullScreenLoading',
            'incrementPossibleFraud',
            'userFatherToReceiveByGateway',
            'addDataNote',
            'setBoletoDetails',
            'setCashDetails',
            'setBankTransferDetails',
            'setNequiDetails',
            'addAllData',
            'selectPaymentMethod',
            'changeStepAction',
            'enabledPaypal',
            'enabledBoleto',
            'setPixDetails',
            'resetVat',
            'setBgResponse'
        ]),
        ...mapActions([
            'validateCoupon',
            'updateNoteInvoice',
            'verifyCurrentPlanUser'
        ]),
        selectedMyCard(indexSelected){
            this.myCards = this.myCards.map((card, index) => {
                card.selected = false;

                if(indexSelected == index) card.selected = true;

                return card;
            })
        },
        changePhone(phone, phoneCompleted){
            this.payu.bankTransfer.phone.fullNumber = `${phoneCompleted.country.dialCode} ${phone}`;
            this.payu.bankTransfer.phone.areaCode = phoneCompleted.country.dialCode;
            this.payu.bankTransfer.phone.number = phoneCompleted.nationalNumber;

            this.payu.nequi.phone.fullNumber = `${phoneCompleted.country.dialCode} ${phone}`;
            this.payu.nequi.phone.areaCode = phoneCompleted.country.dialCode;
            this.payu.nequi.phone.number = phoneCompleted.nationalNumber;

            this.payu.yape.phone.fullNumber = `${phoneCompleted.country.dialCode} ${phone}`;
            this.payu.yape.phone.areaCode = phoneCompleted.country.dialCode;
            this.payu.yape.phone.number = phoneCompleted.nationalNumber;

            this.payu.card.phone.fullNumber = `${phoneCompleted.country.dialCode} ${phone}`;
            this.payu.card.phone.areaCode = phoneCompleted.country.dialCode;
            this.payu.card.phone.number = phoneCompleted.nationalNumber;
            
            this.payu.boleto.phone.fullNumber = `${phoneCompleted.country.dialCode} ${phone}`;
            this.payu.boleto.phone.areaCode = phoneCompleted.country.dialCode;
            this.payu.boleto.phone.number = phoneCompleted.nationalNumber;

            this.verifyActiveContinueStep();
        },
        onBoletoPhoneInput(phone, phoneCompleted){
            this.boletoFieldsTouched = true;
            this.changePhone(phone, phoneCompleted);
        },
        paymentMethod(payment){
            this.selectPaymentMethod(payment);
            this.clearFieldErrors();

            //Stripe
            if(['creditCard'].includes(this.paymentMethodSelected) && ['USD', 'INR', 'AED', 'AUD', 'BRL', 'CAD', 'CHF', 'CLP', 'CZK', 'DKK', 'EGP', 'GBP', 'HKD', 'HUF', 'IDR', 'ILS', 'JPY', 'KES', 'KRW', 'MYR', 'MAD', 'NZD', 'NGN', 'NOK', 'PKR', 'PHP', 'PLN', 'SAR', 'SEK', 'SGD', 'THB', 'TRY', 'TWD', 'VND', 'ZAR', 'ARS', 'MXN', 'PEN', 'COP'].includes(this.product.currency)){
                this.stripe.isVisible = true;

                this.adyen.isVisible = false;
                this.pagarme.isVisible = false;

                this.mountedStripeCreditCard();
            }

            //Stripe
            if(this.paymentMethodSelected == 'googlePay'){
                this.stripe.isVisible = false;
                this.adyen.isVisible = false;
                this.pagarme.isVisible = false;
            }

            //Adyen
            if(['creditCard'].includes(this.paymentMethodSelected) && ['EUR'].includes(this.product.currency) && !this.isFirstPaymentUpLine){
                this.adyen.isVisible = true;

                this.pagarme.isVisible = false;
                this.stripe.isVisible = false;
            }

            //Pagar.me
            if(['pix'].includes(this.paymentMethodSelected) && ['BRL'].includes(this.product.currency) && !this.isFirstPaymentUpLine){
                this.pagarme.isVisible = true;

                this.stripe.isVisible = false;
                this.adyen.isVisible = false;
            }

            //Payu
            if(['cash', 'bankTransfer', 'nequi', 'yape'].includes(this.paymentMethodSelected) && ['ARS', 'MXN', 'COP', 'PEN'].includes(this.product.currency) && !this.isFirstPaymentUpLine){
                this.payu.isVisible = true;

                this.pagarme.isVisible = false;
                this.stripe.isVisible = false;
                this.adyen.isVisible = false;
            }

            //Pagarme - Boleto BRL
            if(['boleto'].includes(this.paymentMethodSelected) && ['BRL'].includes(this.product.currency) && !this.isFirstPaymentUpLine){
                this.pagarme.isVisible = true;

                this.payu.isVisible = false;
                this.stripe.isVisible = false;
                this.adyen.isVisible = false;
            }

            //Payu Credit Card - DISABLED: BRL credit card migrated to Stripe (2026-03-23)
            // if(['creditCard'].includes(this.paymentMethodSelected) && ['BRL'].includes(this.product.currency)){
            //     this.payu.isVisibleCreditCard = true;
            //
            //     this.payu.isVisible = false;
            //     this.adyen.isVisible = false;
            //     this.pagarme.isVisible = false;
            // }

            if(this.paymentMethodSelected == 'creditCard') {
                if(this.product.isTheCurrency.eur && localStorage.getItem('vatFee')){
                    this.addAllData({
                        stateName: 'vatFee',
                        data: JSON.parse(localStorage.getItem('vatFee'))
                    });

                    localStorage.removeItem('vatFee');
                }

                PixelAnalytics.addDataLayer('paymentBySelectedCreditCard');
            }
            if(this.paymentMethodSelected == 'sepa') {
                PixelAnalytics.addDataLayer('paymentBySelectedSepa');
            }

            //Paypal
            if(this.paymentMethodSelected == 'paypal') {
                this.pagarme.isVisible = false;
                this.stripe.isVisible = false;
                this.adyen.isVisible = false;

                if(this.product.isTheCurrency.eur){
                    localStorage.setItem('vatFee', JSON.stringify(this.vatFee));

                    this.addDataNote({nota: {vat_details: []}});

                    this.resetVat();
                }

                if(this.product.first_payment_to_upline && this.userFather.receivement_gateways != null && this.product.currency != 'EUR' && this.userFather.receivement_gateways.hasOwnProperty('paypal')){
                    this.userFatherToReceiveByGateway(true);
                }

                PixelAnalytics.addDataLayer('paymentBySelectedPaypal');
            }

            //PagSeguro
            if(this.paymentMethodSelected == 'pagSeguro') {
                this.pagarme.isVisible = false;
                this.stripe.isVisible = false;
                this.adyen.isVisible = false;

                if(this.product.first_payment_to_upline && this.userFather.receivement_gateways != null && this.product.currency != 'EUR' && this.userFather.receivement_gateways.hasOwnProperty('pagseguro')){
                    this.userFatherToReceiveByGateway(true);
                }

                PixelAnalytics.addDataLayer('paymentBySelectedPagSeguro');
            }

            //Adyen
            if(this.paymentMethodSelected == 'myCards'){
                this.adyen.isVisible = false;
                this.pagarme.isVisible = false;
                this.stripe.isVisible = false;
            }

            this.verifyActiveContinueStep();
        },
        async validCoupon(){
            await this.validateCoupon({
              couponUser: this.couponAddUser,
              isLoadingCheckout: false
            });
        },
        async btnContinue(){
            if(this.disabledBtnContinue) return;

            if(!this.isSendEventAddPaymentInfo){
                PixelAnalytics.createEventPixel('fb', 'AddPaymentInfo', {
                    name: this.product.title,
                    value: this.product.amountCoupon ? this.product.amountCoupon : this.product.amount,
                    currency: this.product.currency
                });

                this.isSendEventAddPaymentInfo = true;
            }

            if(this.stripe.isVisible) {
                this.enabledFullScreenLoading({ status: true, text: !this.product.isTrialDays ? this.translateWord('Efetuando pagamento, aguarde!') : this.translateWord('Criando a sua Conta')});

                this.updateNotesBeforePayment();
                this.finalizePaymentStripe();
                return;
            }

            if(this.adyen.isVisible && this.paymentMethodSelected == 'creditCard'){
                this.enabledFullScreenLoading({ status: true, text: !this.product.isTrialDays ? this.translateWord('Efetuando pagamento, aguarde!') : this.translateWord('Criando a sua Conta')});

                this.updateNotesBeforePayment();
                this.finalizePaymentAdyen();
                return;
            }

            if(this.adyen.isVisible && this.paymentMethodSelected == 'sepa'){
                this.enabledFullScreenLoading({ status: true, text: this.translateWord('Efetuando pagamento, aguarde!') });

                this.updateNotesBeforePayment();
                this.finalizePaymentAdyenSepa();
                return;
            }

            if(this.pagarme.isVisible && this.paymentMethodSelected == 'creditCard'){
                if(!await this.pagarmeCreateToken()) return;

                if(!this.verifyAditionalInfo()) return;

                this.enabledFullScreenLoading({ status: true, text: this.translateWord('Efetuando pagamento, aguarde!') });

                this.updateNotesBeforePayment();
                this.finalizePaymentPagarme();
                return;
            }

            if(this.pagarme.isVisible && this.paymentMethodSelected == 'boleto'){
                if(!this.verifyAditionalInfo()) return;

                this.enabledFullScreenLoading({ status: true, text: this.translateWord('Gerando boleto aguarde!') });

                this.updateNotesBeforePayment();
                this.finalizePaymentPagarmeBoleto();
                return;
            }

            if(this.pagarme.isVisible && this.paymentMethodSelected == 'pix'){
                this.enabledFullScreenLoading({ status: true, text: 'Gerando PIX aguarde!' });

                this.updateNotesBeforePayment();
                this.finalizePaymentPagarmePix();
                return;
            }
            
            if(this.paymentMethodSelected == 'paypal'){
                /*if(this.verifyCountryPricePayPaypal()){
                    this.enabledFullScreenLoading({ status: true });
                    return;
                }*/

                this.enabledFullScreenLoading({ status: true, text: this.translateWord('Você esta sendo redirecionado para o paypal') });

                if(this.product.isBuyAnnual && this.planCountryPrice.hasOwnProperty('annual')){
                    this.addDataNote({
                        periodo: 'ANUAL',
                        valor_desc_adic: this.planCountryPrice.annual.amount
                    });
                }

                await this.updateNotesBeforePayment();
                this.finalizePaymentPaypal();
                return;
            }

            if(['BRL'].includes(this.product.currency) && this.paymentMethodSelected == 'pagSeguro' || this.isFirstPaymentUpLine){
                this.enabledFullScreenLoading({ status: true, text: this.translateWord('Abrindo popup do Pagseguro, aguarde!') });

                this.updateNotesBeforePayment();
                this.finalizePaymentPagseguro();
                return;
            }

            if(this.payu.isVisible && this.paymentMethodSelected == 'cash'){
                this.enabledFullScreenLoading({ status: true, text: this.translateWord('Gerando cash, aguarde!')});

                this.updateNotesBeforePayment();
                this.finalizePaymentPayuCash();
                return;
            }

            if(this.payu.isVisible && this.paymentMethodSelected == 'bankTransfer'){
                this.enabledFullScreenLoading({ status: true, text: this.translateWord('Gerando pagamento com Bank Transfer, aguarde!') });

                this.updateNotesBeforePayment();
                this.finalizePaymentPayuBankTransfer();
                return;
            }

            if(this.payu.isVisible && this.paymentMethodSelected == 'nequi'){
                this.enabledFullScreenLoading({ status: true, text: this.translateWord('Gerando pagamento com Nequi, aguarde!') });

                this.updateNotesBeforePayment();
                this.finalizePaymentPayuNequi();
                return;
            }

            if(this.payu.isVisible && this.paymentMethodSelected == 'yape'){
                this.enabledFullScreenLoading({ status: true, text: this.translateWord('Efetuando pagamento, aguarde!') });

                this.updateNotesBeforePayment();
                this.finalizePaymentPayuYape();
                return;
            }

            if(this.payu.isVisibleCreditCard && this.paymentMethodSelected == 'creditCard'){
                if(!this.verifyPayuCreditCardFields()) return;

                this.enabledFullScreenLoading({ status: true, text: this.translateWord('Efetuando pagamento, aguarde!') });

                this.updateNotesBeforePayment();
                this.finalizePaymentPayuCreditCard();
                return;
            }

            if(this.paymentMethodSelected == 'myCards') {
                this.enabledFullScreenLoading({ status: true, text: this.translateWord('Efetuando pagamento com seu cartão vinculado') });

                this.updateNotesBeforePayment();
                this.finalizePaymentMyCard();
                return;
            }
        },
        async updateNotesBeforePayment(){
            let amountWithoutFee = null;

            if(this.paymentMethodSelected == 'paypal' && this.product.isTheCurrency.eur){
                amountWithoutFee = this.product.amountCoupon ? this.product.amountCoupon : this.product.amount;

                if(isNaN(amountWithoutFee)) this.$logs.post('', ['isNaN no amountWithoutFee.', {
                    product: this.product.title,
                    amountCoupon: this.product.amountCoupon,
                    amountProduct: this.product.amount,
                    amountFirstMonth: this.product.amountFirstMonth,
                    idUser: this.user.user_identifier,
                    invoice: this.fatura.invoice.id,
                }]);

                this.addDataNote({
                    nota: {
                        amount_without_fee: !isNaN(amountWithoutFee) ? amountWithoutFee : this.product.amount
                    }
                });
            }

            await this.updateNoteInvoice();
        },
        async createFuturePaymentAfterPaymentSuccess(){
            let businnesGateway = null;

            if(this.stripe.isVisible) businnesGateway = 'stripe';
            if(this.adyen.isVisible) businnesGateway = 'adyen';
            if(this.pagarme.isVisible) businnesGateway = 'pagarme';
            if(this.payu.isVisibleCreditCard) businnesGateway = 'payu';

            let data = {
                application: 'OFFICE',
                business_gateway: businnesGateway,
                gateway_identifier: this.responseBuilderallGateway.gateway.gateway_identifier,
                is_recurring: true,
                interval: this.isPlan ? this.product.interval : this.product.plan_to_active.interval,
                product: this.isPlan ? this.product.title : this.product.plan_to_active.title,
                period: 'MONTH',
                amount: {
                    currency: this.isPlan ? this.product.currency : this.product.plan_to_active.currency,
                    value: this.isPlan ? this.product.amount : this.product.plan_to_active.amount
                },
                my_data: {
                    vat_details: {},
                    address: {},
                    coupon: {},
                    ip: this.localeUser.ip
                },
                notification_url: this.isPlan ? this.product.webhooks : this.product.plan_to_active.webhooks
            };
            
            if(this.product.isTrialDays){
                data['trial_days'] = this.product.trialDays;
                data.my_data.office_fatura = this.fatura.invoice.id;
            }
            
            if(this.isPlanToActive){
                data.my_data.office_fatura = this.invoicePlanToActive;
                data.my_data.parent_invoice_fee = this.fatura.invoice.id;
            }

            if(this.product.currency == 'EUR' && !this.localeUser.isDutch && this.vatFee.isValid){
                data.my_data.vat_details.number_completed = this.vatFee.vatNumberCompleted;
                data.my_data.vat_details.number = this.vatFee.vatNumber;
                data.my_data.vat_details.country = this.vatFee.vatCountry;
                data.my_data.vat_details.company_name = this.vatFee.vatCompanyName;
                data.my_data.vat_details.company_address = this.vatFee.vatCompanyAddress;
                data.my_data.vat_details.fee = this.vatFee.percentage;
            }

            //Se é da holanda, ja é para cobrar o VAT, mesmo tendo ou nao tendo VAT
            if(this.product.currency == 'EUR' && this.localeUser.isDutch || this.product.currency == 'EUR' && !this.localeUser.isDutch && !this.vatFee.isValid){
                data.fee = this.vatFee.percentage;
                data.my_data.vat_details.fee = this.vatFee.percentage;
            }

            //Se usuario for da Europa com Regiao de Canarias
            if(this.localeUser.isRegionCanarias){
                data.my_data.is_region_canarias = true;
            }

            if(Object.keys(data.my_data.vat_details).length == 0){
                data.my_data.vat_details = null;
            }

            if(['EUR', 'BRL'].includes(this.product.currency)){
                data.my_data.address.zipCode = this.address.zipCode;
                data.my_data.address.city = this.address.city;
                data.my_data.address.street = this.address.street;
                data.my_data.address.country = this.address.country;

                if(this.product.currency == 'BRL') data.my_data.address.state_code = this.address.stateCode;
            }

            if(!['EUR', 'BRL'].includes(this.product.currency)) data.my_data.address = null;

            //Verificar e adicionar disconto
            if(this.hasCouponAndIsValid){
                data.discount = {
                    code: this.coupon.code,
                    value: this.coupon.type == 'FIXED_VALUE' ? parseFloat(Helper.formatValueDiscount(this.product.amount, this.coupon.value, this.coupon.type)).toFixed(2) : this.coupon.value,
                    type: this.coupon.type == 'FIXED_VALUE' ? 'DISCOUNT_FIXED' : 'PERCENTAGE',
                    period: this.coupon.apply_only_first_month == 1 ? 'FIRST_MONTH' : 'FOREVER'
                };

                data.my_data.coupon.id = this.coupon.id;
                data.my_data.coupon.code = this.coupon.code;
            }

            //Verifica se é pagamento por country price
            if(this.isPaymentCountryPrice){
                data.my_data.country_price = this.planCountryPrice;
            }

            if(this.isCoupon100Percent) delete data.my_data;
            
            this.responseBuilderallGatewayFuturePayment = (await this.$http.post(this.endpointGateway.futurePayment, data)).data;
        },
        createDataForSend(){
            let data = {
                application: 'OFFICE',
                product: this.product.title,
                country_code: this.localeUser.country,
                name: this.user.name,
                id_user: this.user.cryptId,
                email: this.user.email,
                address: {},
                my_data: {
                    office_fatura: this.fatura.invoice.id,
                    vat_details: {},
                    address: {},
                    coupon: {},
                    ip: this.localeUser.ip
                },
                amount: {
                    currency: this.product.currency,
                    value: this.product.amount
                },
                notification_url: this.product.webhooks,
                token_checkout: this.tokenCheckout
            };

            if(this.pagarme.isVisible){
                if(this.paymentMethodSelected == 'creditCard') data['token_card'] = this.pagarme.tokenCard;

                if(this.paymentMethodSelected == 'boleto'){
                    //Os inputs do boleto sao compartilhados (payu.boleto.*) independente do gateway destino
                    data['phone'] = {
                        areaCode: this.payu.boleto.phone.areaCode,
                        number: this.payu.boleto.phone.number
                    };
                    data['cpf_or_cnpj'] = this.payu.boleto.cpfOrCnpj;
                }else{
                    data['phone'] = {
                        areaCode: this.pagarme.card.phone.areaCode,
                        number: this.pagarme.card.phone.number
                    };
                    data['cpf_or_cnpj'] = this.pagarme.card.cpfOrCnpj;
                }

                data.address['cep'] = this.address.zipCode;
                data.address['state_code'] = this.address.stateCode;
                data.address['city'] = this.address.city;
                data.address['street'] = `${this.address.number}, ${this.address.street}, ${this.address.district}`;
                data.address['complement'] = this.address.complement;
                data.address['country'] = this.address.country;
            }

            if(this.payu.isVisibleCreditCard){
                // Converte data para formato YYYY/MM se necessário
                let expirationDate = this.payu.card.validate.trim();
                if(expirationDate && expirationDate.includes('/')) {
                    let parts = expirationDate.split('/');
                    let month = parts[0].padStart(2, '0');
                    let year = parts[1];
                    if(year.length === 2) {
                        year = '20' + year;
                    }
                    expirationDate = `${year}/${month}`;
                }

                data['card'] = {
                    name: this.payu.card.holderName,
                    number_card: this.payu.card.number,
                    expiration_date: expirationDate,
                    security_code: this.payu.card.cvc
                };

                data['dni'] = this.cleanDni(this.payu.card.dni);

                data.address['street'] = this.address.street;
                data.address['state_code'] = this.address.stateCode;
                data.address['city'] = this.address.city;
                data.address['country'] = this.localeUser.country;

                data['phone'] = {
                    areaCode: this.payu.bankTransfer.phone.areaCode || this.payu.nequi.phone.areaCode,
                    number: this.payu.bankTransfer.phone.number || this.payu.nequi.phone.number
                };
            }

            if(this.payu.isVisible){
                data['dni'] = this.cleanDni(this.payu.cash.dni || this.payu.bankTransfer.dni || this.payu.nequi.dni || this.payu.yape.dni);

                data.address['street'] = this.address.street;
                data.address['state_code'] = this.address.stateCode;
                data.address['city'] = this.address.city;
                data.address['country'] = this.localeUser.country;

                data['phone'] = {
                    areaCode: this.payu.bankTransfer.phone.areaCode || this.payu.nequi.phone.areaCode || this.payu.boleto.phone.areaCode,
                    number: this.payu.bankTransfer.phone.number || this.payu.nequi.phone.number || this.payu.boleto.phone.number
                };

                if(this.product.currency == 'COP' && this.paymentMethodSelected == 'bankTransfer'){
                    localStorage.setItem('canSkipStep', true);
                    localStorage.setItem('redirectUrlAfterPayment', this.product.redirect);
                    
                    let positionHash = window.location.href.search('#');
                    let urlAfterPayment = `${positionHash !== -1 ? window.location.href.slice(0,positionHash) : window.location.href}${window.location.search == '' ? '?' : '&'}checkoutStep=PaymentConfirmation`
                    
                    data['redir_url_after_payment'] = urlAfterPayment;
                    data['bankTransfer'] = {
                        email: this.payu.bankTransfer.email,
                        bankCode: this.payu.bankTransfer.bankSelected,
                        personType: this.payu.bankTransfer.personTypeSelected,
                        identificationCode: this.payu.bankTransfer.identificationSelected,
                        identificationValue: this.payu.bankTransfer.identification
                    }
                }

                if(this.product.currency == 'COP' && this.paymentMethodSelected == 'nequi'){
                    data['email'] = this.payu.nequi.email;
                }

                if(this.product.currency == 'PEN' && this.paymentMethodSelected == 'yape'){
                    data['yape_code'] = this.payu.yape.code;
                }

                if(this.product.currency == 'BRL' && this.paymentMethodSelected == 'boleto'){
                    data['cpf_or_cnpj'] = this.payu.boleto.cpfOrCnpj;
                }
            }

            if(this.stripe.isVisible && this.paymentMethodSelected == 'creditCard'){
                data['token_card'] = this.stripe.cardSetup.setupIntent.payment_method;
                data['source_token'] = this.stripe.sourceToken;
            }
            
            if(this.adyen.isVisible && this.paymentMethodSelected == 'creditCard'){
                data['card-encrypt'] = this.adyen.cardAdyenEncrypt;
                data['browserInfo'] = {
                    userAgent: navigator.userAgent,
                    lang: navigator.language,
                    colorDepth: screen.colorDepth,
                    screenHeight: screen.height,
                    screenWidth: screen.width,
                    timezoneOffset: (new Date).getTimezoneOffset(),
                    javaEnabled: navigator.javaEnabled ? navigator.javaEnabled() : false
                }
            }
            
            if(this.adyen.isVisible && this.paymentMethodSelected == 'sepa'){
                data['owner_name'] = this.adyen.sepa.ownerName;
                data['iban_number'] = this.adyen.sepa.ibanNumber;
            }

            if(this.product.currency == 'EUR' && !this.localeUser.isDutch && this.vatFee.isValid){
                data.my_data.vat_details.number_completed = this.vatFee.vatNumberCompleted;
                data.my_data.vat_details.number = this.vatFee.vatNumber;
                data.my_data.vat_details.country = this.vatFee.vatCountry;
                data.my_data.vat_details.company_name = this.vatFee.vatCompanyName;
                data.my_data.vat_details.company_address = this.vatFee.vatCompanyAddress;
                data.my_data.vat_details.fee = this.vatFee.percentage;
            }

            //Se é da holanda, ja é para cobrar o VAT, mesmo tendo ou nao tendo VAT
            if(this.product.currency == 'EUR' && this.localeUser.isDutch || this.product.currency == 'EUR' && !this.localeUser.isDutch && !this.vatFee.isValid){
                data.fee = this.vatFee.percentage;
                data.my_data.vat_details.fee = this.vatFee.percentage;
            }

            //Se usuario for da Europa com Regiao de Canarias
            if(this.localeUser.isRegionCanarias){
                data.my_data.is_region_canarias = true;
            }

            if(Object.keys(data.my_data.vat_details).length == 0){
                data.my_data.vat_details = null;
            }

            if(['EUR', 'BRL'].includes(this.product.currency)){
                data.my_data.address.zipCode = this.address.zipCode;
                data.my_data.address.city = this.address.city;
                data.my_data.address.street = this.address.street;
                data.my_data.address.country = this.address.country;

                if(this.product.currency == 'BRL') data.my_data.address.state_code = this.address.stateCode;
            }

            if(!['EUR', 'BRL'].includes(this.product.currency)) data.my_data.address = null;


            if(this.isPlan){
                data.is_recurring = true;
                data.interval = this.product.interval;
                data.period = 'MONTH';

                //Plano launch system: primeiro pagamento da recorrencia em 3 meses (~90 dias)
                if(Helper.slugsLaunchSystemPlan.includes(this.$route.params.slug)){
                    data.interval = 3;
                    data.period = 'MONTH';
                }
            }

            //Verificar e adicionar disconto
            if(this.hasCouponAndIsValid){
                data.discount = {
                    code: this.coupon.code,
                    value: this.coupon.type == 'FIXED_VALUE' ? parseFloat(Helper.formatValueDiscount(this.product.amount, this.coupon.value, this.coupon.type)).toFixed(2) : this.coupon.value,
                    type: this.coupon.type == 'FIXED_VALUE' ? 'DISCOUNT_FIXED' : 'PERCENTAGE',
                    period: this.coupon.period,
                    time: this.coupon.periodTime
                }
            }

            if(this.product.isAmountFirstMonth){
                data['amount']['first_month'] = this.product.amountFirstMonth;
            }

            //TEMP Webnar 27 de dezembro
            if(['3156', '3025'].includes(this.product.id)){
                if(this.product.isAmountFirstMonth){
                    data['amount']['first_month'] = this.product.amountFirstMonth;
                }
            }

            if(this.product.isTrialDays || this.isCoupon100Percent){
                data['first_payment_without_charge'] = true;
            }

            if(this.isPlanToActive){
                data.my_data.invoice_plan_to_active = this.invoicePlanToActive;
            }

            if(this.hasCouponAndIsValid){
                data.my_data.coupon.id = this.coupon.id;
                data.my_data.coupon.code = this.coupon.code;
            }

            if(this.isPauseAccount){
                data.my_data['pause_account'] = true;
            }

            //Verifica se é pagamento por country price
            if(this.isPaymentCountryPrice){
                data.my_data.country_price = this.planCountryPrice;

                if(this.planCountryPrice.hasOwnProperty('annual') && this.product.isBuyAnnual){
                    data.my_data.country_price.is_payment_annual = true;
                }

            }

            //Verificar bumpsell 
            if(this.hasBumpsellAndSelected){                
                let itemsBumpsell = this.bumpsell.filter(item => item.check).map(item => (
                    {
                        slug: item.slug, 
                        amount: parseFloat(item.price).toFixed(2),
                        product: item.title
                    }
                ));

                data.amount.value = this.product.amountFixed;
                
                data['bumpsell'] = itemsBumpsell;
                
                data.my_data.buy_bumpsell = itemsBumpsell;
            }

            //Verify purchase upwork
            if(this.hasUpwork){
                data.my_data.purchase_upwork = true;
            }

            return data;
        },
        createDataPaymentMyCard(){
            let hashToken = this.myCards.filter(card => card.selected)[0].token;

            let data = {
                application: 'OFFICE',
                product: this.product.title,
                token: hashToken,
                my_data: {
                    office_fatura: this.fatura.invoice.id,
                    vat_details: {},
                    address: {},
                    coupon: {},
                    ip: this.localeUser.ip,
                    payment_type: 'one_click'
                },
                amount: {
                    value: this.product.amount
                },
                notification_url: this.product.webhooks
            };

            if(this.product.currency == 'EUR' && !this.localeUser.isDutch && this.vatFee.isValid){
                data.my_data.vat_details.number_completed = this.vatFee.vatNumberCompleted;
                data.my_data.vat_details.number = this.vatFee.vatNumber;
                data.my_data.vat_details.country = this.vatFee.vatCountry;
                data.my_data.vat_details.company_name = this.vatFee.vatCompanyName;
                data.my_data.vat_details.company_address = this.vatFee.vatCompanyAddress;
                data.my_data.vat_details.fee = this.vatFee.percentage;
            }

            //Se é da holanda, ja é para cobrar o VAT, mesmo tendo ou nao tendo VAT
            if(this.product.currency == 'EUR' && this.localeUser.isDutch || this.product.currency == 'EUR' && !this.localeUser.isDutch && !this.vatFee.isValid){
                data.fee = this.vatFee.percentage;
                data.my_data.vat_details.fee = this.vatFee.percentage;
            }

            //Se usuario for da Europa com Regiao de Canarias
            if(this.localeUser.isRegionCanarias){
                data.my_data.is_region_canarias = true;
            }

            if(Object.keys(data.my_data.vat_details).length == 0){
                data.my_data.vat_details = null;
            }

            if(this.product.currency == 'EUR'){
                data.my_data.address.zipCode = this.address.zipCode;
                data.my_data.address.city = this.address.city;
                data.my_data.address.street = this.address.street;
                data.my_data.address.country = this.address.country;
            }

            if(this.product.currency != 'EUR') data.my_data.address = null;


            if(this.isPlan){
                data.is_recurring = true;
                data.interval = this.product.interval;
                data.period = 'MONTH';

                //Plano launch system: primeiro pagamento da recorrencia em 3 meses (~90 dias)
                if(Helper.slugsLaunchSystemPlan.includes(this.$route.params.slug)){
                    data.interval = 3;
                    data.period = 'MONTH';
                }
            }

            //Verificar e adicionar disconto
            if(this.hasCouponAndIsValid){
                data.discount = {
                    code: this.coupon.code,
                    value: this.coupon.type == 'FIXED_VALUE' ? parseFloat(Helper.formatValueDiscount(this.product.amount, this.coupon.value, this.coupon.type)).toFixed(2) : this.coupon.value,
                    type: this.coupon.type == 'FIXED_VALUE' ? 'DISCOUNT_FIXED' : 'PERCENTAGE',
                    period: this.coupon.period,
                    time: this.coupon.periodTime
                }
            }

            if(this.product.isAmountFirstMonth){
                data['amount']['first_month'] = this.product.amountFirstMonth;
            }

            if(this.product.isTrialDays){
                data['trial_days'] = this.product.trialDays;
            }

            if(this.hasCouponAndIsValid){
                data.my_data.coupon.id = this.coupon.id;
                data.my_data.coupon.code = this.coupon.code;
            }

            if(this.isPauseAccount){
                data.my_data['pause_account'] = true;
            }

            //Verifica se é pagamento por country price
            if(this.isPaymentCountryPrice){
                data.my_data.country_price = this.planCountryPrice;

                if(this.planCountryPrice.hasOwnProperty('annual') && this.product.isBuyAnnual){
                    data.my_data.country_price.is_payment_annual = true;
                }

            }

            //Verificar bumpsell 
            if(this.hasBumpsellAndSelected){                
                let itemsBumpsell = this.bumpsell.filter(item => item.check).map(item => (
                    {
                        slug: item.slug, 
                        amount: parseFloat(item.price).toFixed(2),
                        product: item.title
                    }
                ));

                data.amount.value = this.product.amountFixed;
                
                data['bumpsell'] = itemsBumpsell;
                
                data.my_data.buy_bumpsell = itemsBumpsell;
            }

            //Verify purchase upwork
            if(this.hasUpwork){
                data.my_data.purchase_upwork = true;
            }

            return data;
        },
        /**
         *  Caso o gateway tiver a seguraça 3DS. Funcionalidade para redicionar o usuario para finalizar a compra de forma segura no site do emissor do cartão.
         */
        paymentRedirectUser3Ds(gateway, data){
            localStorage.setItem('canSkipStep', true);
            localStorage.setItem('redirectUrlAfterPayment', this.product.redirect);
            localStorage.setItem('vatFee', JSON.stringify(this.vatFee));
            localStorage.setItem('localeUser', JSON.stringify(this.localeUser));

            this.enabledFullScreenLoading({
                status: true,
                text: this.translateWord('Voce sera redirecionado para finalizar o pagamento no site do emissor do seu cartão!'),
            });

            if(gateway == 'adyen'){
                this.adyen.threeDS.issuerUrl = data.issuerUrl;
                this.adyen.threeDS.md = data.md;
                this.adyen.threeDS.paRequest = data.paRequest;
                this.adyen.threeDS.termUrl = data.termUrl;

                //Tempo para que os dados seja inseridos no DOM.
                setTimeout(() => this.$refs.threeDSAdyen.click() , 2000)
            }
        },
        async paymentSuccess(){
            if(this.isPlanToActive) await this.createFuturePaymentAfterPaymentSuccess();

            this.nextStepWithEmit();
        },
        paymentRefused(){
            this.enabledFullScreenLoading({ status: false})
            this.sendFailedPaymentEmail(this.responseBuilderallGateway.gateway.reason || 'payment_refused');

            if(this.responseBuilderallGateway.gateway.status == 'Error' && this.responseBuilderallGateway.gateway.message == 'payment_refused' && this.responseBuilderallGateway.gateway.hasOwnProperty('reason')){
                return this.paymentError(this.responseBuilderallGateway.gateway.message, this.responseBuilderallGateway.gateway.reason, this.responseBuilderallGateway.gateway.type);
            }

            return this.$Notify.info({
                title: this.translateWord('Erro no analise'),
                message: this.responseBuilderallGateway.message,
                duration: 0
            });
        },
        paymentError(message, reason, type){
            this.sendFailedPaymentEmail(reason || message);

            if(['pagarme_boleto_single'].includes(type)){
                return this.$Notify.error({
                    title: this.translateWord('Erro ao gerar boleto'),
                    message: this.translateWord('Não foi possivel gerar o seu boleto. Verifique se o seu CPF/CNPJ, telefone e endereço esta preenchido corretamente.'),
                    duration: 0
                });
            }

            if(this.responseBuilderallGateway.gateway.type == 'pagarme_multiple'){
                return this.$Notify.error({
                    title: this.translateWord('Erro ao efetuar pagamento'),
                    message: this.responseBuilderallGateway.gateway.reason,
                    duration: 0
                });
            }

            if(reason == 'unable_to_determine_variant'){
                return this.$Notify.warning({
                    message: this.translateWord('Unable to determine variant'),
                    duration: 0
                });
            }

            if(reason == 'invalid_card_number'){
                return this.$Notify.warning({
                    message: this.translateWord('O Numéro do cartão é inválido'),
                    duration: 0
                });
            }

            if(reason == 'card_holder_missing'){
                return this.$Notify.warning({
                    message: this.translateWord('O Titular do cartão esta incorreto'),
                    duration: 0
                });
            }

            if(reason == 'expiry_date_invalid'){
                return this.$Notify.warning({
                    message: this.translateWord('Data de validade inválida'),
                    duration: 0
                });
            }

            if(reason == 'cvc_is_not_the_right_length'){
                return this.$Notify.warning({
                    message: this.translateWord('O CVC não tem o tamanho certo'),
                    duration: 0
                });
            }

            if(reason == 'not_supported'){
                return this.$Notify.warning({
                    message: this.translateWord('Cartão de pagamento não suportado, favor tente com outro cartão'),
                    duration: 0
                });
            }

            if(reason == 'cvc_declined'){
                return this.$Notify.warning({
                    message: this.translateWord('Código de segurança do cartão é invalido'),
                    duration: 0
                });
            }

            if(reason == 'payment_details_are_not_supported'){
                return this.$Notify.warning({
                    message: this.translateWord('Bandeira de cartão não disponivel para pagamento'),
                    duration: 0
                });
            }

            if(reason == 'possible_fraud'){
                this.incrementPossibleFraud();

                if(this.totalPossibleFraud > Helper.possibleFraudAttempts){
                    return this.blockUserReasonFraud(response.data);
                }

                return this.$Notify.error({
                    message: this.translateWord('Identificamos que o cartão utilizado está sob suspeita de FRAUDE, caso continue utilizando-o, sua conta será bloqueada.'),
                    duration: 0
                });
            }

            if(reason == 'user_block_blacklist'){
                return this.$Notify.warning({
                    message: this.translateWord('Você esta na blacklist por identificarmos como usuario fraudulento. Caso não seja entre em contato com suporte.'),
                    duration: 0
                });
            }

            if(message == 'payment_refused'){
                return this.$Notify.info({
                    message: this.translateWord('Seu pagamento foi recussado, verifique os dados do cartão corretamente!'),
                    duration: 0
                });
            }
        },
        sendFailedPaymentEmail(reasonFailed) {
            let gateway = 'unknown';
            if(this.stripe.isVisible) gateway = 'stripe';
            else if(this.adyen.isVisible) gateway = 'adyen';
            else if(this.pagarme.isVisible) gateway = 'pagarme';
            else if(this.payu.isVisible || this.payu.isVisibleCreditCard) gateway = 'payu';

            this.$http.post('/notification/send-failed-payment-email', {
                id_user: this.user.user_identifier,
                id_invoice: this.fatura && this.fatura.invoice ? this.fatura.invoice.id : null,
                name: this.user.name,
                email: this.user.email,
                country: this.localeUser.country,
                currency: this.product.currency,
                amount: this.product.amount,
                type: gateway + '_' + this.paymentMethodSelected,
                reason_failed: reasonFailed,
                first_payment: this.user.first_payment == null ? 1 : 0
            }).catch(() => {});
        },
        blockUserReasonFraud(gateway){
            let date = new Date();
            let data = {
                invoice_id: this.fatura.invoice.id,
                cryptId: this.usuario.cryptId,
                reason: 'fraud',
                event_date: date.toISOString(),
                amount: {
                    currency: gateway.gateway.currency,
                    value: gateway.gateway.amount
                }
            };

            this.$httpOfficeAdmin.post(this.endpointOffice.FRAUDE, data).then(response => {
                if(response.data.status == 'success'){
                    window.location.href = this.urlOfficeUser;
                }
            });
        },
        async mountedStripeCreditCard(){
            let publicKey = ['prod'].includes(Helper.getEnvs().env)
                ? 'pk_live_bazKLrAu8IndMZPY0AmzJjFT'
                : 'pk_test_QnTgAa0SQy9J1rGdambcpWAd';
            
            this.stripe.instance = Stripe(publicKey, {
                locale: this.localeUserCheckoutStripe()
            });
            this.stripe.setupIntent = await this.$http.post(this.endpointGateway.setupIntentStripe, {
                application: 'OFFICE'
            }).then(res => res.data.gateway);

            // Create an instance of Elements.
            this.stripe.elements = this.stripe.instance.elements();

            // Create an instance of the card Element.
            this.stripe.card = this.stripe.elements.create('card', {style: {
                    base: {
                        color: '#32325d',
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '14px',
                        '::placeholder': {
                            color: '#aab7c4'
                        }
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                }});

            // Add an instance of the card Element into the `card-element` <div>.
            this.stripe.card.mount('#stripe-element');

            // Handle real-time validation errors from the card Element.
            this.stripe.card.addEventListener('change', event => {
                if (event.error) {
                    this.sendFailedPaymentEmail(event.error.message || 'stripe_card_validation_error');

                    return this.$Notify.info({
                        title: this.translateWord('Erro no cartão'),
                        message: event.error.message,
                        duration: 0
                    });
                }
            });
        },
        async mountedStripeWallet(){
            let publicKey = ['prod'].includes(Helper.getEnvs().env)
                ? 'pk_live_bazKLrAu8IndMZPY0AmzJjFT'
                : 'pk_test_QnTgAa0SQy9J1rGdambcpWAd';
            
            this.stripe.instanceWallet = Stripe(publicKey, {
                locale: this.localeUserCheckoutStripe()
            });

            const options = {
                mode: 'payment',
                amount: this.productAmount * 100,
                currency: this.product.currency.toLowerCase(),
                setupFutureUsage: 'off_session',
                appearance: {},
            };

            // Set up Stripe.js and Elements to use in checkout form.
            const elements = this.stripe.instanceWallet.elements(options);
            this.stripe.elementsWallet = elements; // Salva referência para atualizar depois
            const expressCheckout = elements.create('expressCheckout', {
                paymentMethods: {
                    applePay: 'always',
                    googlePay: 'always',
                    amazonPay: 'auto',
                    link: 'never',
                    paypal: 'never'
                },
                paymentMethodOrder: ['googlePay', 'applePay', 'amazonPay'], //'googlePay', 'applePay', 'amazonPay'
                layout: {
                    maxColumns: 3,
                    maxRows: 3
                }
            });

            setTimeout(() => expressCheckout.mount('#stripe-wallets'), 400);

            expressCheckout.on('ready', ({availablePaymentMethods}) => {
                    document.querySelector('#stripe-wallets-loading').remove();
            });

            expressCheckout.on('confirm', async (event) => {
                try{
                    this.paymentMethod('googlePay');

                    this.enabledFullScreenLoading({ status: true, text: this.translateWord('Efetuando pagamento, aguarde!') });

                    const {error: submitError} = await elements.submit();
                    if (submitError) {
                        this.enabledFullScreenLoading({ status: false});
                        this.sendFailedPaymentEmail(submitError.message || 'stripe_wallet_submit_error');
                        return;
                    }

                    // Create a ConfirmationToken using the details collected by the Express Checkout Element
                    const {error, confirmationToken} = await this.stripe.instanceWallet.createConfirmationToken({
                        elements,
                        params: {
                            payment_method_data: {
                                billing_details: {
                                    name: this.user.name,
                                }
                            }
                        }
                    });
                    console.log(confirmationToken);

                    let clientSecret = (await this.$http.post(this.endpointGateway.paymentIntentStripe, this.createDataForSend()).then(res => res.data.gateway))['client_secret'];
                    let idConfirmationToken = confirmationToken.id;

                    // Confirm the PaymentIntent
                    const {error: confirmError} = await this.stripe.instanceWallet.confirmPayment({
                        clientSecret,
                        confirmParams: {
                            confirmation_token: idConfirmationToken
                        },
                        redirect: "if_required",
                    });

                    if (confirmError) {
                        this.enabledFullScreenLoading({ status: false});
                        this.sendFailedPaymentEmail(confirmError.message || 'stripe_wallet_confirm_error');
                        console.log(confirmError);
                        return;
                    }

                    return this.paymentSuccess();
                }catch(error){
                    this.enabledFullScreenLoading({ status: false});
                    this.sendFailedPaymentEmail(error.message || 'stripe_wallet_error');

                    return this.$Notify.info({
                        message: 'Failed payment with wallet',
                        duration: 0
                    });
                }
            });
        },
        localeUserCheckoutStripe(){
            return 'en';
            
            /*let locale = this.localeUser.country.toLowerCase();
            
            if(locale == 'br') return 'pt-BR';  
            
            return locale;*/
        },
        async pagarmeCreateToken(){
            let key = Helper.getEnvs().env == 'prod' ? 'pk_rqGdR00SxTZ8XDlL' : 'pk_test_WA01Q0JCBUNyGV9r';

            try{
                let tokenCard = (await axios.post(`https://api.pagar.me/core/v5/tokens?appId=${key}`, {
                    card: {
                        number: this.pagarme.card.number.split(' ').join(''),
                        holder_name: this.pagarme.card.holderName,
                        exp_month: this.pagarme.card.expiryMonth,
                        exp_year: this.pagarme.card.expiryYear,
                        cvv: this.pagarme.card.cvc
                    },
                    type: 'card'
                })).data;

                this.pagarme.tokenCard = tokenCard.id;

                return true;
            }catch(exception){
                let error = Object.entries(exception.response.data.errors)[0][0];
                this.sendFailedPaymentEmail(error || 'pagarme_token_error');

                if(error == 'request.card.holder_name'){
                    this.$Notify.info({
                        title: 'INFORMAÇÃO DO CARTÃO',
                        message: 'O Nome do titular do cartão, não pode conter caracteres especiais',
                        duration: 0
                    });
                }

                if(error == 'request.card.number'){
                    this.$Notify.info({
                        title: 'INFORMAÇÃO DO CARTÃO',
                        message: 'O numero informado do cartão nao é valido. Verifique e tente novamente.',
                        duration: 0
                    });
                }

                if(error == 'request.card.exp_month'){
                    this.$Notify.info({
                        title: 'INFORMAÇÃO DO CARTÃO',
                        message: 'Data de validade do cartão é invalida. Verifique e tente novamente.',
                        duration: 0
                    });
                }

                if(error == 'request.card.cvv'){
                    this.$Notify.info({
                        title: 'INFORMAÇÃO DO CARTÃO',
                        message: 'CVV/CVC inválido. É preciso ter no minimo 3 digitos e no maximo 4. Verifique e tente novamente.',
                        duration: 0
                    });
                }

                return false;
            }

        },
        async finalizePaymentPagarme(){
            if(!this.verifyAddressUser()) {
                this.enabledFullScreenLoading({ status: false});
                this.sendFailedPaymentEmail('address_invalid');

                this.$Notify.info({
                    message: this.translateWord('Para finalizar o pagamento, é preciso preencher o endereço'),
                    duration: 0
                });

                return;
            }

            this.$Notify.info({
                title: this.translateWord('Analisando cartão'),
                message: this.translateWord('Estamos enviando os dados do seu cartão para analise, aguarde...')
            });

            try{
                this.responseBuilderallGateway = (await this.$http.post(this.getEndpoint(), this.createDataForSend())).data;

                if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_authorized'){
                    if(this.product.isTrialDays || this.isCoupon100Percent){
                        await this.createFuturePaymentAfterPaymentSuccess();
                        return this.paymentSuccess();
                    }

                    return this.paymentSuccess();
                }

                if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_done') return this.paymentSuccess();

                return this.paymentRefused();

            }catch(error){
                this.enabledFullScreenLoading({ status: false});
                this.sendFailedPaymentEmail(error.message || 'pagarme_credit_card_error');

                return this.$Notify.warning({
                    title: this.translateWord('Erro requisição'),
                    message: this.translateWord('Ocorreu algum na requisição, favor tente mais tarde'),
                    duration: 0
                });
            };
        },
        async finalizePaymentPagarmeBoleto(){
            if(!this.verifyAddressUser()) {
                this.enabledFullScreenLoading({ status: false});
                this.sendFailedPaymentEmail('address_invalid');

                this.$Notify.info({
                    message: this.translateWord('Para finalizar o pagamento, é preciso preencher o endereço'),
                    duration: 0
                });

                return;
            }

            try{
                this.responseBuilderallGateway = (await this.$http.post(this.getEndpoint(), this.createDataForSend())).data;

                if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_pending'){
                    this.setBoletoDetails({
                        barCode: this.responseBuilderallGateway.gateway.boleto.barcode_number,
                        barCodeImage: this.responseBuilderallGateway.gateway.boleto.barcode_image,
                        downloadPdf: this.responseBuilderallGateway.gateway.boleto.url_download,
                        qrCode: this.responseBuilderallGateway.gateway.boleto.qrcode
                    });

                    this.paymentSuccess();

                    return;
                }

                return this.paymentRefused();

            }catch(error){
                this.enabledFullScreenLoading({ status: false});
                this.sendFailedPaymentEmail(error.message || 'pagarme_boleto_error');

                return this.$Notify.warning({
                    title: this.translateWord('Erro requisição'),
                    message: this.translateWord('Ocorreu algum na requisição, favor tente mais tarde'),
                    duration: 0
                });
            };
        },
        async finalizePaymentPayuBoleto(){
            if(!this.verifyAddressUser()) {
                this.enabledFullScreenLoading({ status: false});
                this.sendFailedPaymentEmail('address_invalid');

                this.$Notify.info({
                    message: this.translateWord('Para finalizar o pagamento, é preciso preencher o endereço'),
                    duration: 0
                });

                return;
            }

            try{
                this.responseBuilderallGateway = (await this.$http.post(this.getEndpoint(), this.createDataForSend())).data;

                if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_pending'){
                    this.setBoletoDetails({
                        barCode: this.responseBuilderallGateway.gateway.boleto.barcode || '',
                        downloadPdf: this.responseBuilderallGateway.gateway.boleto.url_download || ''
                    });

                    this.paymentSuccess();

                    return;
                }

                return this.paymentRefused();

            }catch(error){
                this.enabledFullScreenLoading({ status: false});
                this.sendFailedPaymentEmail(error.message || 'payu_boleto_error');

                return this.$Notify.warning({
                    title: this.translateWord('Erro requisição'),
                    message: this.translateWord('Ocorreu algum na requisição, favor tente mais tarde'),
                    duration: 0
                });
            };
        },
        async finalizePaymentPagarmePix(){
            try{
                this.responseBuilderallGateway = (await this.$http.post(this.getEndpoint(), this.createDataForSend())).data;

                if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_pending'){
                    
                    this.setBgResponse({ payment: this.responseBuilderallGateway });

                    this.setPixDetails({
                        qrCode: this.responseBuilderallGateway.gateway.pix.qr_code,
                        qrCodeUrl: this.responseBuilderallGateway.gateway.pix.qr_code_url
                    });

                    this.paymentSuccess();

                    return;
                }

                return this.paymentRefused();

            }catch(error){
                this.enabledFullScreenLoading({ status: false});
                this.sendFailedPaymentEmail(error.message || 'pagarme_pix_error');

                return this.$Notify.warning({
                    title: this.translateWord('Erro requisição'),
                    message: this.translateWord('Ocorreu algum na requisição, favor tente mais tarde'),
                    duration: 0
                });
            };
        },
        async finalizePaymentAdyen(){
            if(this.adyen.isThreeSecureUrl && this.adyen.threeSecureIdentify && this.adyen.isPaymentThreeSecure){
                this.responseBuilderallGateway = (await this.$http.post(this.endpointGateway.paymentAdyen, {
                    application: 'OFFICE',
                    is_3d_secure: true,
                    identify_cache: this.adyen.threeSecureIdentify,
                    id_user: this.user.cryptId,
                    amount: {
                        currency: this.product.currency
                    }
                })).data;

                if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_done') return this.paymentSuccess();

                return this.paymentRefused();
            }

            if(!this.verifyDataCardIsValid()) return this.enabledFullScreenLoading({ status: false});

            if(!this.verifyAddressUser()) {
                this.enabledFullScreenLoading({ status: false});
                this.sendFailedPaymentEmail('address_invalid');

                this.$Notify.info({
                    message: this.translateWord('Para finalizar o pagamento, é preciso preencher o endereço'),
                    duration: 0
                });

                return;
            }

            this.$Notify.info({
                title: this.translateWord('Analisando cartão'),
                message: this.translateWord('Estamos enviando os dados do seu cartão para analise, aguarde...')
            });

            try{
                this.responseBuilderallGateway = (await this.$http.post(this.getEndpoint(), this.createDataForSend())).data;

                if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_redirect_user'){
                    let positionHash = window.location.href.search('#');
                    let urlAfterPayment = `${positionHash !== -1 ? window.location.href.slice(0,positionHash) : window.location.href}${window.location.search == '' ? '?' : '&'}checkoutStep=Payment&threeSecure=1&invoice=${this.fatura.invoice.id}`;

                    return this.paymentRedirectUser3Ds('adyen', {
                        issuerUrl: this.responseBuilderallGateway.gateway.others.issuerUrl,
                        md: this.responseBuilderallGateway.gateway.others.md,
                        paRequest: this.responseBuilderallGateway.gateway.others.paRequest,
                        termUrl: `${Helper.getEnvs().urlCheckout}/adyen/3d-secure?identify=${encodeURIComponent(this.user.name)}_${(new Date()).getTime()}&returnUrl=${encodeURIComponent(urlAfterPayment)}`
                    });
                }

                if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_authorized'){
                    if(this.product.isTrialDays || this.isCoupon100Percent){
                        await this.createFuturePaymentAfterPaymentSuccess();
                        return this.paymentSuccess();
                    }

                    return this.paymentSuccess();
                }
                
                if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_done') return this.paymentSuccess();

                return this.paymentRefused();

            }catch(error){
                this.enabledFullScreenLoading({ status: false});
                this.sendFailedPaymentEmail(error.message || 'adyen_credit_card_error');

                return this.$Notify.warning({
                    title: this.translateWord('Erro requisição'),
                    message: this.translateWord('Ocorreu algum na requisição, favor tente mais tarde'),
                    duration: 0
                });
            };
        },
        async finalizePaymentAdyenSepa(){
            if(!this.verifyDataSepaIsValid()) return this.enabledFullScreenLoading({ status: false});

            if(!this.verifyAddressUser()) {
                this.enabledFullScreenLoading({ status: false});
                this.sendFailedPaymentEmail('address_invalid');

                this.$Notify.info({
                    message: this.translateWord('Para finalizar o pagamento, é preciso preencher o endereço'),
                    duration: 0
                });

                return;
            }

            this.$Notify.info({
                title: this.translateWord('Verificando conta'),
                message: this.translateWord('Estamos verificando sua conta  IBAN!')
            });

            try{
                this.responseBuilderallGateway = (await this.$http.post(this.getEndpoint(), this.createDataForSend())).data;

                if(this.responseBuilderallGateway.gateway.status == 'Success') return this.paymentSuccess();

                return this.paymentRefused();

            }catch(error){
                this.enabledFullScreenLoading({ status: false});
                this.sendFailedPaymentEmail(error.message || 'adyen_sepa_error');

                return this.$Notify.warning({
                    title: this.translateWord('Erro requisição'),
                    message: this.translateWord('Ocorreu algum na requisição, favor tente mais tarde'),
                    duration: 0
                });
            };
        },
        async finalizePaymentPaypal(){
            localStorage.setItem('canSkipStep', true);
            localStorage.setItem('redirectUrlAfterPayment', this.product.redirect);
            
            let positionHash = window.location.href.search('#');
            let urlAfterPayment = `${positionHash !== -1 ? window.location.href.slice(0,positionHash) : window.location.href}${window.location.search == '' ? '?' : '&'}checkoutStep=PaymentConfirmation`
            if(this.isUserFatherToReceiveByGateway) await this.checkUpdateInvoiceFirstPayment();

            if(this.isChargedAmount){
                let cpData = {
                    cp: 1,
                    cp_planId: this.product.id,
                    cp_currency: this.product.currency,
                    cp_amount: this.product.amount,
                    cp_symbol: this.product.currencySymbol
                };

                this.addDataNote({
                    nota: {
                        ref: btoa(unescape(encodeURIComponent(JSON.stringify(cpData))))
                    }
                });
            }

            if(this.isPaymentCountryPrice && !this.isChargedAmount){
                let cpAmount = this.planCountryPrice.amount;
                let cpAmountRef = this.planCountryPrice.amountRef;

                if(this.product.isBuyAnnual && this.planCountryPrice.hasOwnProperty('annual')){
                    cpAmount = this.planCountryPrice.annual.amount;
                    cpAmountRef = this.planCountryPrice.annual.amountRef;
                }

                let cpData = {
                    cp: 1,
                    cp_planId: this.product.id,
                    cp_currency: this.planCountryPrice.currency,
                    cp_amount: cpAmount,
                    cp_symbol: this.planCountryPrice.symbol,
                    cp_currencyRef: this.planCountryPrice.currencyRef,
                    cp_amountRef: cpAmountRef,
                    cp_fakeAmount: this.planCountryPrice.fakeAmount,
                };

                if(this.product.isBuyAnnual && this.planCountryPrice.hasOwnProperty('annual')){
                    cpData.cp_annual = 1;
                }

                if(!this.product.isBuyAnnual && this.planCountryPrice.amountFirstMonth > 0){
                    cpData.cp_amountFirstMonth = this.planCountryPrice.amountFirstMonth;
                    cpData.cp_amountFirstMonthRef = this.planCountryPrice.amountFirstMonthRef;
                }

                this.addDataNote({
                    nota: {
                        ref: btoa(unescape(encodeURIComponent(JSON.stringify(cpData))))
                    }
                });
            }

            await this.updateNoteInvoice();

            //Adicionando cupom na sessao para integração com a impact
            //Ao realizar a integração com o novo paypal, pode remover. Pois não vai ser necessario sair do checkout para finalizar o pagamento com o paypal
            if(this.hasCouponAndIsValid){
                sessionStorage.setItem('coupon_impact_paypal', true);
                sessionStorage.setItem('coupon_impact_orderPromoCode', this.coupon.code);
                sessionStorage.setItem('coupon_impact_orderDiscount', this.product.amountCouponDiscount);
            }

            // "/0/1" é para forçar o redirecionamento para o PayPal
            let url = `${Helper.getEnvs().urlOffice}/${this.user.lang}/${this.endpointOffice.INVOICE_PAY}/${this.fatura.invoice.id}/0/1?allow_internal_payment=1&${this.$route.query['user-id'] != undefined ? `user-id=${this.$route.query['user-id']}&invoice=${this.fatura.invoice.id}&` : ''}force_redir_url=${encodeURIComponent(urlAfterPayment)}`;

            window.location.href = url;
        },
        async finalizePaymentPayuCash(){
            // if(!this.verifyAddressUser()) {
            //     this.enabledFullScreenLoading({ status: false});

            //     this.$Notify.info({
            //         message: this.translateWord('Para finalizar o pagamento, é preciso preencher o endereço'),
            //         duration: 0
            //     });

            //     return;
            // }

            try{
                this.responseBuilderallGateway = (await this.$http.post(this.getEndpoint(), this.createDataForSend())).data;

                if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_pending'){
                    this.setCashDetails({
                        barCode: this.responseBuilderallGateway.gateway.cash.barcode_number,
                        downloadPdf: this.responseBuilderallGateway.gateway.cash.url_download,
                    });

                    this.paymentSuccess();

                    return;
                }

                return this.paymentRefused();

            }catch(error){
                this.enabledFullScreenLoading({ status: false});
                this.sendFailedPaymentEmail(error.message || 'payu_cash_error');

                return this.$Notify.warning({
                    title: this.translateWord('Erro requisição'),
                    message: this.translateWord('Ocorreu algum na requisição, favor tente mais tarde'),
                    duration: 0
                });
            };
        },
        async finalizePaymentPayuBankTransfer(){
            try{
                this.responseBuilderallGateway = (await this.$http.post(this.getEndpoint(), this.createDataForSend())).data;

                if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_pending'){
                    this.setBankTransferDetails({
                        barCode: this.responseBuilderallGateway.gateway.bank_transfer.spei_number,
                        downloadPdf: this.responseBuilderallGateway.gateway.bank_transfer.url_download,
                        bankUrl: this.responseBuilderallGateway.gateway.bank_transfer.url_redir
                    });

                    this.paymentSuccess();

                    return;
                }

                return this.paymentRefused();

            }catch(error){
                this.enabledFullScreenLoading({ status: false});
                this.sendFailedPaymentEmail(error.message || 'payu_bank_transfer_error');

                return this.$Notify.warning({
                    title: this.translateWord('Erro requisição'),
                    message: this.translateWord('Ocorreu algum na requisição, favor tente mais tarde'),
                    duration: 0
                });
            };
        },
        async finalizePaymentPayuNequi(){
            try{
                this.responseBuilderallGateway = (await this.$http.post(this.getEndpoint(), this.createDataForSend())).data;

                if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_pending'){
                    console.log(this.responseBuilderallGateway.gateway.nequi.url_access);
                    this.setNequiDetails({
                        urlAccess: this.responseBuilderallGateway.gateway.nequi.url_access,
                    });

                    this.paymentSuccess();

                    return;
                }

                return this.paymentRefused();

            }catch(error){
                this.enabledFullScreenLoading({ status: false});
                this.sendFailedPaymentEmail(error.message || 'payu_nequi_error');

                return this.$Notify.warning({
                    title: this.translateWord('Erro requisição'),
                    message: this.translateWord('Ocorreu algum na requisição, favor tente mais tarde'),
                    duration: 0
                });
            };
        },
        async finalizePaymentPayuYape(){
            try{
                this.responseBuilderallGateway = (await this.$http.post(this.getEndpoint(), this.createDataForSend())).data;

                if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_done'){
                    this.paymentSuccess();
                    return;
                }

                return this.paymentRefused();

            }catch(error){
                this.enabledFullScreenLoading({ status: false});
                this.sendFailedPaymentEmail(error.message || 'payu_yape_error');

                return this.$Notify.warning({
                    title: this.translateWord('Erro requisição'),
                    message: this.translateWord('Ocorreu algum na requisição, favor tente mais tarde'),
                    duration: 0
                });
            };
        },
        async finalizePaymentPayuCreditCard(){
            try{
                this.responseBuilderallGateway = (await this.$http.post(this.getEndpoint(), this.createDataForSend())).data;

                if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_authorized'){
                    if(this.product.isTrialDays || this.isCoupon100Percent){
                        await this.createFuturePaymentAfterPaymentSuccess();
                        return this.paymentSuccess();
                    }

                    return this.paymentSuccess();
                }

                if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_done'){
                    this.paymentSuccess();
                    return;
                }

                return this.paymentRefused();

            }catch(error){
                this.enabledFullScreenLoading({ status: false});
                this.sendFailedPaymentEmail(error.message || 'payu_credit_card_error');

                return this.$Notify.warning({
                    title: this.translateWord('Erro requisição'),
                    message: this.translateWord('Ocorreu algum na requisição, favor tente mais tarde'),
                    duration: 0
                });
            };
        },
        async finalizePaymentPagseguro(){
            let formData = new FormData();
            formData.append('id', this.fatura.invoice.id);
            formData.append('id_usuario', this.user.user_identifier);
            formData.append('id_franquia', 30877);

            if(this.isUserFatherToReceiveByGateway) await this.checkUpdateInvoiceFirstPayment();
            
            let codePagSeguro = (await this.$httpOffice.post(`${this.endpointOffice.PAGSEGURO}${!this.isPlan ? '/SINGLE' : ''}`, formData,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
            )).data['code'];

            /*if(Helper.isMobile()){
                return window.location.href = Helper.getEnvs().env == 'prod' 
                    ? `https://pagseguro.uol.com.br/v2/checkout/payment.html?code=${codePagSeguro}`
                    : `https://sandbox.pagseguro.uol.com.br/v2/checkout/payment.html?code=${codePagSeguro}`;
            }*/

            PagSeguroLightbox({ code: codePagSeguro }, {
                success:  (result) => {
                    this.enabledFullScreenLoading({ status: false});
                    this.paymentSuccess();
                },
                abort: (abort) => {
                    this.enabledFullScreenLoading({ status: false});
                    console.log('abort:', abort);
                }
            });
        },
        verifyCountryPricePayPaypal(){
            if(this.isPaymentCountryPrice){
                let planStyle = TempRedirPlan.verifyAccessUserPlan(this.getSlug, this.product.currency);
                localStorage.setItem('canSkipStep', true);

                if(planStyle == 'COUNTRY_PRICE') window.location.href = `${TempRedirPlan.getUrlRedir()}?checkoutStep=Payment&paymentMethod=paypal`;

                return true;
            }
        },
        verifyDataSepaIsValid(){
            if(this.adyen.sepa.ownerName == ''){
                this.$Notify.warning({
                    title: this.translateWord('Owner Name'),
                    message: this.translateWord('O Campo Owner Name não pode ficar vazio'),
                    duration: 0
                });
                this.sendFailedPaymentEmail('sepa_owner_name_empty');
                return false;
            }

            if(this.adyen.sepa.ibanNumber == ''){
                this.$Notify.warning({
                    title: this.translateWord('IBAN Number'),
                    message: this.translateWord('O Campo IBAN Number não pode ficar vazio'),
                    duration: 0
                });
                this.sendFailedPaymentEmail('sepa_iban_number_empty');
                return false;
            }

            return true;
        },
        verifyDataCardIsValid(){
            let publicKey = ['prod'].includes(Helper.getEnvs().env)
                ? this.adyenKeys.publicKeyLive
                : this.adyenKeys.publicKeyTest;

            let cseInstance = adyen.encrypt.createEncryption(publicKey, {
                enableValidations: false
            });

            this.adyen.cardAdyenEncrypt = cseInstance.encrypt(this.adyen.card);
            let card = cseInstance.validate(this.adyen.card);
            
            if(!card.valid){
                let invalidFields = [];
                if(!card.number){
                    invalidFields.push('number');
                    this.$Notify.warning({
                        title: this.translateWord('Numéro inválido'),
                        message: this.translateWord('O Numéro do cartão é inválido'),
                        duration: 0
                    });
                }

                if(!card.holderName){
                    invalidFields.push('holderName');
                    this.$Notify.warning({
                        title: this.translateWord('Titular inválido'),
                        message: this.translateWord('O Titular do cartão esta incorreto'),
                        duration: 0
                    });
                }

                if(!card.expiryYear){
                    invalidFields.push('expiryYear');
                    this.$Notify.warning({
                        title: this.translateWord('Ano inválido'),
                        message: this.translateWord('O Ano de expiração do cartão é inválido'),
                        duration: 0
                    });
                }

                if(!card.expiryMonth){
                    invalidFields.push('expiryMonth');
                    this.$Notify.warning({
                        title: this.translateWord('Mês invalido'),
                        message: this.translateWord('O mês de expiração do cartão é inválido'),
                        duration: 0
                    });
                }

                if(!card.cvc){
                    invalidFields.push('cvc');
                    this.$Notify.warning({
                        title: this.translateWord('CVC invalido'),
                        message: this.translateWord('O CVC é inválido'),
                        duration: 0
                    });
                }

                this.sendFailedPaymentEmail('adyen_card_validation_failed: ' + invalidFields.join(', '));
                return false;
            }

            return true;
        },
        verifyAddressUser(){
            if(this.product.currency == 'BRL'){
                return Object.values({
                    zipCode: this.address.zipCode,
                    city: this.address.city,
                    street: this.address.street,
                    stateCode: this.address.stateCode
                }).every(data => data != '');
            }

            return Object.values({
                zipCode: this.address.zipCode,
                city: this.address.city,
                street: this.address.street,
                country: this.address.country
            }).every(data => data != '');
        },
        verifyAditionalInfo(){
            let cpfOrCnpj = this.payu.boleto.cpfOrCnpj;

            let isCpf = CpfVerifier.isValid(cpfOrCnpj);
            let isCnpf = CnpjVerifier.isValid(cpfOrCnpj);

            if(isCpf || isCnpf) return true;

            this.$Notify.info({
                title: this.translateWord('CPF/CNPJ Invalido'),
                message: this.translateWord("O CPF/CNPJ informado não esta correto. Verifique e tente novamente."),
                duration: 0
            });
            this.sendFailedPaymentEmail('cpf_cnpj_invalid');

            return false;
        },
        verifyPayuCreditCardFields(){
            let regex = /^(0?[1-9]|1[0-2])\/(\d{2}|\d{4})$/;
            let val = this.payu.card.validate ? this.payu.card.validate.trim() : '';
            if(!val || !regex.test(val)){
                this.$Notify.warning({
                    message: this.translateWord('Data de validade invalida')
                });
                this.sendFailedPaymentEmail('payu_card_expiry_invalid');
                return false;
            }

            let [month, year] = val.split('/');
            if(year.length === 2) year = '20' + year;
            let expiry = new Date(parseInt(year), parseInt(month), 0);
            if(expiry < new Date()){
                this.$Notify.warning({
                    message: this.translateWord('Cartão expirado')
                });
                this.sendFailedPaymentEmail('payu_card_expired');
                return false;
            }

            return true;
        },
        async finalizePaymentStripe(){
            if(this.stripe.holderName == ''){
                this.enabledFullScreenLoading({ status: false});

                this.stripe.fieldsValidators.holderNameIsValid = false;
                this.sendFailedPaymentEmail('stripe_holder_name_empty');

                return this.$Notify.info({
                    title: this.translateWord('Titular inválido'),
                    message: this.translateWord('O Titular do cartão esta incorreto'),
                    duration: 0
                });
            }

            this.$Notify.info({
                title: this.translateWord('Analisando cartão'),
                message: this.translateWord('Estamos enviando os dados do seu cartão para analise, aguarde...')
            });

            try{
                this.stripe.sourceToken = await this.stripe.instance.createToken(this.stripe.card).then(res => res);

                if(this.stripe.sourceToken.error){
                    this.enabledFullScreenLoading({status: false});
                    this.sendFailedPaymentEmail(this.stripe.sourceToken.error.message || 'stripe_token_error');

                    this.$logs.post('', [`Falha na criação do cartao com Stripe: ${this.user.name} | ${this.user.user_identifier}`, {
                        message: this.stripe.cardSetup.error,
                        product: this.product.title
                    }, 'ERROR']);

                    return this.$Notify.info({
                        title: this.translateWord('Erro na autenticação do cartão'),
                        message: this.translateWord('Ocorreu o seguinte error no analise do cartão') + `: ${this.stripe.sourceToken.error.message}`,
                        duration: 0
                    });
                }

                this.stripe.sourceToken = this.stripe.sourceToken.token.id;

                this.stripe.cardSetup = await this.stripe.instance.handleCardSetup(this.stripe.setupIntent.client_secret, this.stripe.card, {
                    payment_method_data: {
                        billing_details: {
                            name: this.stripe.holderName
                        }
                    }
                });

                if(this.stripe.cardSetup.error){
                    this.enabledFullScreenLoading({status: false});
                    this.sendFailedPaymentEmail(this.stripe.cardSetup.error.message || 'stripe_card_setup_error');

                    this.$logs.post('', [`Falha na criação do cartao com Stripe: ${this.user.name} | ${this.user.user_identifier}`, {
                        message: this.stripe.cardSetup.error,
                        product: this.product.title
                    }, 'ERROR']);

                    return this.$Notify.info({
                        title: this.translateWord('Erro na autenticação do cartão'),
                        message: this.translateWord('Ocorreu o seguinte error no analise do cartão') + `: ${this.stripe.cardSetup.error.message}`,
                        duration: 0
                    });
                }
            }catch(error){
                this.enabledFullScreenLoading({status: false});
                this.sendFailedPaymentEmail(error.message || 'stripe_token_request_error');

                return this.$Notify.warning({
                    title: this.translateWord('Erro requisição'),
                    message: this.translateWord('Ops infelizmente ocorreu um error ao realizar a requisição de pagamento, favor tente mais tarde'),
                    duration: 0
                });
            }


            try{
                this.responseBuilderallGateway = (await this.$http.post(this.getEndpoint(), this.createDataForSend())).data;

                if(this.responseBuilderallGateway.gateway.message == 'payment_authentication_required'){
                    let isAuthorized = await this.scaAuthenticationRequiredStripe();

                    if(isAuthorized) return this.paymentSuccess();
                }else{
                    if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_authorized'){
                        if(this.product.isTrialDays || this.isCoupon100Percent){
                            await this.createFuturePaymentAfterPaymentSuccess();
                            return this.paymentSuccess();
                        }

                        return this.paymentSuccess();
                    }
                    
                    if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_done'){

                        this.setBgResponse({ payment: this.responseBuilderallGateway });

                        return this.paymentSuccess();
                    }
                }

                return this.paymentRefused();

            }catch(error){
                this.enabledFullScreenLoading({status: false});
                this.sendFailedPaymentEmail(error.message || 'stripe_payment_error');

                return this.$Notify.warning({
                    title: this.translateWord('Erro requisição'),
                    message: this.translateWord('Ops infelizmente ocorreu um error ao realizar a requisição de pagamento, favor tente mais tarde'),
                    duration: 0
                });
            };
        },
        async scaAuthenticationRequiredStripe(newResponseBuilderallGateway){
            let response = newResponseBuilderallGateway || this.responseBuilderallGateway;

            let client_secret = response.gateway.others.error.payment_intent.client_secret;
            let payment_method = response.gateway.others.error.payment_method.id;

            let resultIntent = await this.stripe.instance.handleCardPayment(client_secret, {
                payment_method: payment_method
            });

            return resultIntent.paymentIntent.status == 'succeeded' ? true : false;
        },
        async finalizePaymentMyCard(){
            this.responseBuilderallGateway = (await this.$http.post(this.endpointGateway.debitPaymentTokenCard, this.createDataPaymentMyCard())).data;

            if(this.responseBuilderallGateway.gateway.status == 'Success' && this.responseBuilderallGateway.gateway.message == 'payment_done'){
                this.setBgResponse({ payment: this.responseBuilderallGateway });

                return this.paymentSuccess();
            }

            return this.paymentRefused();
        },
        /**
         * Pega o endpoint se é para pagamento com stripe ou adyen)
         *
         * @returns {string}
         */
        getEndpoint(){
            if(this.stripe.isVisible) return this.endpointGateway.paymentStripe;
            if(this.adyen.isVisible && this.paymentMethodSelected == 'creditCard') return this.endpointGateway.paymentAdyen;
            if(this.adyen.isVisible && this.paymentMethodSelected == 'sepa') return this.endpointGateway.sepa;
            if(this.pagarme.isVisible && this.paymentMethodSelected == 'creditCard') return this.endpointGateway.paymentPagarme;
            if(this.pagarme.isVisible && this.paymentMethodSelected == 'boleto') return this.endpointGateway.paymentPagarmeBoleto;
            if(this.pagarme.isVisible && this.paymentMethodSelected == 'pix') return this.endpointGateway.paymentPagarmePix;
            if(this.payu.isVisible && this.paymentMethodSelected == 'cash') return this.endpointGateway.paymentPayuCash;
            if(this.payu.isVisible && this.paymentMethodSelected == 'bankTransfer') return this.endpointGateway.paymentPayuBankTransfer;
            if(this.payu.isVisible && this.paymentMethodSelected == 'nequi') return this.endpointGateway.paymentPayuNequi;
            if(this.payu.isVisible && this.paymentMethodSelected == 'yape') return this.endpointGateway.paymentPayuYape;
            if(this.payu.isVisibleCreditCard && this.paymentMethodSelected == 'creditCard') return this.endpointGateway.paymentPayuCreditCard;
        },
        async searchLocaleZipCode(){
            if(this.adyen.isVisible) await this.searchZipCodeEurope();
            if(this.pagarme.isVisible || this.payu.isVisible) await this.searchZipCodeBrazil();
        },
        async searchZipCodeEurope(){
            if(this.address.zipCode == '' || this.address.country != '' || this.address.city != '') return;

            this.enabledFullScreenLoading({ status: true, text: this.translateWord('Analisando localização pelo CEP') });

            try{
                let result = (await axios.get(`https://api.zippopotam.us/${this.localeUser.country}/${this.address.zipCode}`)).data;

                this.address.city = result.places[0]['place name'];
                this.address.country = result.country;

                this.enabledFullScreenLoading({status: false});
            }catch(error){
                this.$Notify.warning({
                    message: this.translateWord('Infelizmente não conseguimos recuperar a localização pelo CEP. Favor preencha manualmente')
                });

                this.enabledFullScreenLoading({status: false});
            }

            this.verifyActiveContinueStep();
        },
        async searchZipCodeBrazil(){
            if(this.address.zipCode == '' || this.address.city != '') return;

            this.enabledFullScreenLoading({ status: true, text: this.translateWord('Analisando localização pelo CEP') });

            try{
                let result = (await axios.get(`https://viacep.com.br/ws/${this.address.zipCode}/json/`)).data;

                this.address.stateCode = result.uf;
                this.address.city = result.localidade;
                this.address.street = result.logradouro;
                this.address.district = result.bairro;
                this.address.country = 'BR';

                this.enabledFullScreenLoading({status: false});
            }catch(error){
                this.$Notify.warning({
                    message: this.translateWord('Infelizmente não conseguimos recuperar a localização pelo CEP. Favor preencha manualmente')
                });

                //Caso preencha manualmente, setar o BR.
                this.address.country = 'BR';

                this.enabledFullScreenLoading({status: false});
            }

            this.verifyActiveContinueStep();
        },
        validateFieldOnBlur(field, value){
            if(!value || !value.trim()) return this.translateWord('Campo obrigatório');

            switch(field){
                case 'holderName':
                    return cardValidator.cardholderName(value).isValid ? '' : this.translateWord('Nome inválido');
                case 'cardNumber':
                    return cardValidator.number(value).isValid ? '' : this.translateWord('Número do cartão inválido');
                case 'cardValidate': {
                    let regex = /^(0?[1-9]|1[0-2])\/(\d{2}|\d{4})$/;
                    if(!regex.test(value.trim())) return this.translateWord('Data de validade inválida');
                    let [month, year] = value.trim().split('/');
                    if(year.length === 2) year = '20' + year;
                    let now = new Date();
                    let expiry = new Date(parseInt(year), parseInt(month), 0);
                    return expiry >= now ? '' : this.translateWord('Cartão expirado');
                }
                case 'cardCvc': {
                    let cardNum = this.payu.isVisibleCreditCard ? this.payu.card.number : (this.adyen.isVisible ? this.adyen.card.number : this.pagarme.card.number);
                    let maxLen = cardValidator.number(cardNum).card;
                    let cvcSize = maxLen ? maxLen.code.size : 3;
                    return cardValidator.cvv(value, cvcSize).isValid ? '' : this.translateWord('CVV inválido');
                }
                case 'dni':
                    return this.isValidDni(value) ? '' : this.translateWord('Documento inválido');
                case 'phone':
                    return value.replace(/\D/g, '').length >= 7 ? '' : this.translateWord('Telefone inválido');
                case 'phoneBr':
                    return value.replace(/\D/g, '').length >= 10 ? '' : this.translateWord('Telefone inválido');
                case 'cpfOrCnpj': {
                    let digits = value.replace(/\D/g, '');
                    return (digits.length == 11 || digits.length == 14) ? '' : this.translateWord('CPF ou CNPJ inválido');
                }
                case 'yapeCode':
                    return value.replace(/\D/g, '').length == 6 ? '' : this.translateWord('Código Yape inválido');
                case 'email':
                    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()) ? '' : this.translateWord('E-mail inválido');
                case 'required':
                    return value.trim() ? '' : this.translateWord('Campo obrigatório');
                default:
                    return '';
            }
        },
        clearFieldErrors(){
            this.fieldErrors.payu.card = { holderName: '', number: '', validate: '', cvc: '', dni: '', phone: '' };
            this.fieldErrors.payu.cash = { dni: '' };
            this.fieldErrors.payu.bankTransfer = { dni: '', identification: '', email: '', phone: '', bankSelected: '', personTypeSelected: '', identificationSelected: '' };
            this.fieldErrors.payu.nequi = { dni: '', phone: '', email: '' };
            this.fieldErrors.payu.yape = { dni: '', code: '', phone: '', email: '' };
            this.fieldErrors.adyen.card = { holderName: '', number: '', validate: '', cvc: '' };
            this.fieldErrors.pagarme.card = { holderName: '', number: '', validate: '', cvc: '', phone: '', cpfOrCnpj: '' };
            this.fieldErrors.pix = { phone: '', cpfOrCnpj: '' };
            this.fieldErrors.boleto = { phone: '', cpfOrCnpj: '' };
            this.fieldErrors.address = { zipCode: '', country: '', stateCode: '', city: '', district: '', street: '', number: '' };
        },
        cleanDni(value){
            if(!value) return '';
            // MXN (CURP/RFC) é alfanumérico — apenas trim
            if(this.product.currency == 'MXN') return value.trim();
            // Demais moedas — remover tudo que não é dígito
            return value.replace(/\D/g, '');
        },
        isValidDni(value){
            let digits = value.replace(/\D/g, '');

            switch(this.product.currency){
                case 'BRL': return digits.length == 11 || digits.length == 14; // CPF ou CNPJ
                case 'PEN': return digits.length == 8; // DNI Peru
                case 'ARS': return digits.length >= 7 && digits.length <= 11; // DNI 7-8 ou CUIT 11
                case 'COP': return digits.length >= 6 && digits.length <= 10; // CC 6-10
                case 'MXN': return value.trim().length >= 12 && value.trim().length <= 18; // RFC 12-13 ou CURP 18 (alfanumérico)
                default: return value.trim().length >= 5;
            }
        },
        verifyActiveContinueStep(){
            // Limpa erro do campo quando o valor digitado fica válido
            if(this.paymentMethodSelected == 'creditCard' && this.payu.isVisibleCreditCard){
                if(this.fieldErrors.payu.card.holderName && cardValidator.cardholderName(this.payu.card.holderName).isValid) this.fieldErrors.payu.card.holderName = '';
                if(this.fieldErrors.payu.card.number && cardValidator.number(this.payu.card.number).isValid) this.fieldErrors.payu.card.number = '';
                if(this.fieldErrors.payu.card.validate && /^(0?[1-9]|1[0-2])\/(\d{2}|\d{4})$/.test(this.payu.card.validate.trim())) this.fieldErrors.payu.card.validate = '';
                if(this.fieldErrors.payu.card.cvc && cardValidator.cvv(this.payu.card.cvc).isValid) this.fieldErrors.payu.card.cvc = '';
                if(this.fieldErrors.payu.card.dni && this.isValidDni(this.payu.card.dni)) this.fieldErrors.payu.card.dni = '';
            }
            if(this.paymentMethodSelected == 'creditCard' && this.adyen.isVisible){
                if(this.fieldErrors.adyen.card.holderName && cardValidator.cardholderName(this.adyen.card.holderName).isValid) this.fieldErrors.adyen.card.holderName = '';
                if(this.fieldErrors.adyen.card.number && cardValidator.number(this.adyen.card.number).isValid) this.fieldErrors.adyen.card.number = '';
                if(this.fieldErrors.adyen.card.validate && /^(0?[1-9]|1[0-2])\/(\d{2}|\d{4})$/.test(this.adyen.validate.trim())) this.fieldErrors.adyen.card.validate = '';
                if(this.fieldErrors.adyen.card.cvc && cardValidator.cvv(this.adyen.card.cvc).isValid) this.fieldErrors.adyen.card.cvc = '';
            }
            if(this.paymentMethodSelected == 'creditCard' && this.pagarme.isVisible){
                if(this.fieldErrors.pagarme.card.holderName && cardValidator.cardholderName(this.pagarme.card.holderName).isValid) this.fieldErrors.pagarme.card.holderName = '';
                if(this.fieldErrors.pagarme.card.number && cardValidator.number(this.pagarme.card.number).isValid) this.fieldErrors.pagarme.card.number = '';
                if(this.fieldErrors.pagarme.card.validate && /^(0?[1-9]|1[0-2])\/(\d{2}|\d{4})$/.test(this.pagarme.card.validate.trim())) this.fieldErrors.pagarme.card.validate = '';
                if(this.fieldErrors.pagarme.card.cvc && cardValidator.cvv(this.pagarme.card.cvc).isValid) this.fieldErrors.pagarme.card.cvc = '';
                let phone = this.pagarme.card.phone.areaCodeAndNumber ? this.pagarme.card.phone.areaCodeAndNumber.replace(/\D/g, '') : '';
                if(this.fieldErrors.pagarme.card.phone && phone.length >= 10) this.fieldErrors.pagarme.card.phone = '';
                let cpf = this.pagarme.card.cpfOrCnpj ? this.pagarme.card.cpfOrCnpj.replace(/\D/g, '') : '';
                if(this.fieldErrors.pagarme.card.cpfOrCnpj && (cpf.length == 11 || cpf.length == 14)) this.fieldErrors.pagarme.card.cpfOrCnpj = '';
            }
            if(this.paymentMethodSelected == 'cash' && this.fieldErrors.payu.cash.dni && this.isValidDni(this.payu.cash.dni)) this.fieldErrors.payu.cash.dni = '';
            if(this.paymentMethodSelected == 'bankTransfer' && this.fieldErrors.payu.bankTransfer.dni && this.isValidDni(this.payu.bankTransfer.dni)) this.fieldErrors.payu.bankTransfer.dni = '';
            if(this.paymentMethodSelected == 'bankTransfer' && this.fieldErrors.payu.bankTransfer.identification && this.payu.bankTransfer.identification.trim()) this.fieldErrors.payu.bankTransfer.identification = '';
            if(this.paymentMethodSelected == 'bankTransfer' && this.fieldErrors.payu.bankTransfer.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.payu.bankTransfer.email.trim())) this.fieldErrors.payu.bankTransfer.email = '';
            if(this.paymentMethodSelected == 'nequi' && this.fieldErrors.payu.nequi.dni && this.isValidDni(this.payu.nequi.dni)) this.fieldErrors.payu.nequi.dni = '';
            if(this.paymentMethodSelected == 'nequi' && this.fieldErrors.payu.nequi.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.payu.nequi.email.trim())) this.fieldErrors.payu.nequi.email = '';
            if(this.paymentMethodSelected == 'yape'){
                if(this.fieldErrors.payu.yape.dni && this.isValidDni(this.payu.yape.dni)) this.fieldErrors.payu.yape.dni = '';
                if(this.fieldErrors.payu.yape.code && this.payu.yape.code.replace(/\D/g, '').length == 6) this.fieldErrors.payu.yape.code = '';
                if(this.fieldErrors.payu.yape.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.payu.yape.email.trim())) this.fieldErrors.payu.yape.email = '';
            }

            // Auto-clear endereço
            if(this.fieldErrors.address.zipCode && this.address.zipCode.trim()) this.fieldErrors.address.zipCode = '';
            if(this.fieldErrors.address.country && this.address.country.trim()) this.fieldErrors.address.country = '';
            if(this.fieldErrors.address.stateCode && this.address.stateCode.trim()) this.fieldErrors.address.stateCode = '';
            if(this.fieldErrors.address.city && this.address.city.trim()) this.fieldErrors.address.city = '';
            if(this.fieldErrors.address.district && this.address.district.trim()) this.fieldErrors.address.district = '';
            if(this.fieldErrors.address.street && this.address.street.trim()) this.fieldErrors.address.street = '';
            if(this.fieldErrors.address.number && this.address.number.trim()) this.fieldErrors.address.number = '';

            if(!this.isCheckCouponFixedValue) return this.disabledBtnContinue = true;

            // Métodos sem campos manuais — sempre habilitado
            if(['paypal', 'googlePay', 'myCards', 'pagSeguro'].includes(this.paymentMethodSelected)){
                this.disabledBtnContinue = false;
                return;
            }

            if(this.isFirstPaymentUpLine){
                this.disabledBtnContinue = false;
                return;
            }

            // Credit Card — depende do gateway
            if(this.paymentMethodSelected == 'creditCard'){
                if(this.payu.isVisibleCreditCard){
                    let numberValidation = cardValidator.number(this.payu.card.number);
                    let cvvMaxLength = numberValidation.card ? numberValidation.card.code.size : 3;

                    let isValid =
                        cardValidator.cardholderName(this.payu.card.holderName).isValid &&
                        numberValidation.isValid &&
                        cardValidator.expirationDate(this.payu.card.validate).isValid &&
                        cardValidator.cvv(this.payu.card.cvc, cvvMaxLength).isValid &&
                        this.isValidDni(this.payu.card.dni) &&
                        this.payu.card.phone.fullNumber.replace(/\D/g, '').length >= 7 &&
                        this.address.zipCode.trim() != '' &&
                        this.address.city.trim() != '' &&
                        this.address.street.trim() != '';

                    if(this.product.currency == 'BRL'){
                        isValid = isValid && this.address.stateCode.trim() != '';
                    }

                    this.disabledBtnContinue = !isValid;
                    return;
                }

                if(this.pagarme.isVisible){
                    let numberValidation = cardValidator.number(this.pagarme.card.number);
                    let cvvMaxLength = numberValidation.card ? numberValidation.card.code.size : 3;
                    let phone = this.pagarme.card.phone.areaCodeAndNumber.replace(/\D/g, '');
                    let cpfCnpj = this.pagarme.card.cpfOrCnpj.replace(/\D/g, '');

                    this.disabledBtnContinue = !(
                        cardValidator.cardholderName(this.pagarme.card.holderName).isValid &&
                        numberValidation.isValid &&
                        cardValidator.expirationDate(this.pagarme.card.validate).isValid &&
                        cardValidator.cvv(this.pagarme.card.cvc, cvvMaxLength).isValid &&
                        phone.length >= 10 &&
                        (cpfCnpj.length == 11 || cpfCnpj.length == 14)
                    );
                    return;
                }

                if(this.adyen.isVisible){
                    this.checkFieldsCreditCard();
                    this.checkFieldsAddress();
                    let cardFieldsValidate = Object.entries(this.adyen.fieldsValidators).map(res => res[1].test).every(test => test == true);
                    let addressFieldsValidate = Object.entries(this.address.fieldsValidators).map(res => res[1].test).every(test => test == true);
                    this.disabledBtnContinue = this.product.currency == 'EUR' ? !(cardFieldsValidate && addressFieldsValidate) : !cardFieldsValidate;
                    return;
                }

                if(this.stripe.isVisible){
                    this.checkFieldsStripeHolderName();
                    this.disabledBtnContinue = !this.stripe.fieldsValidators.holderName.test;
                    return;
                }
            }

            // SEPA
            if(this.paymentMethodSelected == 'sepa'){
                this.checkFieldsSepa();
                this.checkFieldsAddress();
                let sepaFieldsValidate = Object.entries(this.adyen.sepa.fieldsValidators).map(res => res[1].test).every(test => test == true);
                let addressFieldsValidate = Object.entries(this.address.fieldsValidators).map(res => res[1].test).every(test => test == true);
                this.disabledBtnContinue = !(sepaFieldsValidate && addressFieldsValidate);
                return;
            }

            // PIX
            if(this.paymentMethodSelected == 'pix'){
                let phone = this.pagarme.card.phone.areaCodeAndNumber.replace(/\D/g, '');
                let cpfCnpj = this.pagarme.card.cpfOrCnpj.replace(/\D/g, '');

                this.disabledBtnContinue = !(
                    phone.length >= 10 &&
                    (cpfCnpj.length == 11 || cpfCnpj.length == 14)
                );
                return;
            }

            // Boleto
            if(this.paymentMethodSelected == 'boleto'){
                if(!this.boletoFieldsTouched){
                    this.disabledBtnContinue = true;
                    return;
                }

                let cpfCnpj = this.payu.boleto.cpfOrCnpj.replace(/\D/g, '');

                let isValid =
                    this.payu.boleto.phone.fullNumber.replace(/\D/g, '').length >= 7 &&
                    (cpfCnpj.length == 11 || cpfCnpj.length == 14) &&
                    this.address.zipCode.trim() != '' &&
                    this.address.city.trim() != '' &&
                    this.address.street.trim() != '';

                if(this.product.currency == 'BRL'){
                    isValid = isValid &&
                        this.address.stateCode.trim() != '' &&
                        this.address.district.trim() != '' &&
                        this.address.number.trim() != '';
                }
                if(this.product.currency == 'EUR'){
                    isValid = isValid && this.address.country.trim() != '';
                }

                this.disabledBtnContinue = !isValid;
                return;
            }

            // Cash
            if(this.paymentMethodSelected == 'cash'){
                this.disabledBtnContinue = !(
                    this.isValidDni(this.payu.cash.dni) &&
                    this.address.street.trim() != '' &&
                    this.address.city.trim() != '' &&
                    this.address.stateCode.trim() != ''
                );
                return;
            }

            // Bank Transfer
            if(this.paymentMethodSelected == 'bankTransfer'){
                let isValid =
                    this.isValidDni(this.payu.bankTransfer.dni) &&
                    this.address.street.trim() != '' &&
                    this.address.city.trim() != '' &&
                    this.address.stateCode.trim() != '';

                if(this.product.currency == 'COP'){
                    isValid = isValid &&
                        this.payu.bankTransfer.email.trim() != '' &&
                        this.payu.bankTransfer.bankSelected != '' &&
                        this.payu.bankTransfer.personTypeSelected != '' &&
                        this.payu.bankTransfer.identificationSelected != '' &&
                        this.payu.bankTransfer.identification.trim() != '' &&
                        this.payu.bankTransfer.phone.fullNumber.trim() != '';
                }

                this.disabledBtnContinue = !isValid;
                return;
            }

            // Nequi
            if(this.paymentMethodSelected == 'nequi'){
                this.disabledBtnContinue = !(
                    this.payu.nequi.email.trim() != '' &&
                    this.isValidDni(this.payu.nequi.dni) &&
                    this.payu.nequi.phone.fullNumber.trim() != ''
                );
                return;
            }

            // Yape
            if(this.paymentMethodSelected == 'yape'){
                this.disabledBtnContinue = !(
                    this.payu.yape.email.trim() != '' &&
                    this.isValidDni(this.payu.yape.dni) &&
                    this.payu.yape.phone.fullNumber.trim() != '' &&
                    this.payu.yape.code.trim() != ''
                );
                return;
            }

            this.disabledBtnContinue = true;
        },
        checkFieldsStripeHolderName(){
            this.stripe.fieldsValidators.holderName.test = this.stripe.holderName != '' ? true : false;
        },
        checkFieldsCreditCard(){
            this.adyen.fieldsValidators.holderName.test = this.adyen.card.holderName != '' ? true : false;
            this.adyen.fieldsValidators.number.test = this.adyen.card.number != '' ? true : false;
            this.adyen.fieldsValidators.validate.test = this.adyen.validate != '' ? true : false;
            this.adyen.fieldsValidators.cvc.test = this.adyen.card.cvc != '' ? true : false;
        },
        checkFieldsSepa(){
            this.adyen.sepa.fieldsValidators.ownerName.test = this.adyen.sepa.ownerName != '' ? true : false;
            this.adyen.sepa.fieldsValidators.ibanNumber.test = this.adyen.sepa.ibanNumber != '' ? true : false;
        },
        checkFieldsAddress(){
            this.address.fieldsValidators.zipCode.test = this.address.zipCode != '' ? true : false;
            this.address.fieldsValidators.country.test = this.address.country != '' ? true : false;
            this.address.fieldsValidators.city.test = this.address.city != '' ? true : false;
            this.address.fieldsValidators.street.test = this.address.street != '' ? true : false;
        },
        async checkUpdateInvoiceFirstPayment(){
            if(!this.isFirstPaymentUpLine) return;

            //UPline receber via Paypal
            if(this.isFirstPaymentUpLine && this.userFather.receivement_gateways.hasOwnProperty('paypal') && this.paymentMethodSelected == 'paypal'){
                this.addDataNote({
                    recorrente: 0,
                    valor_desc_adic: this.product.amountFirstMonth,
                    nota: {
                        upline_first_payment: {
                            gateway: 'paypal',
                            identifier: this.userFather.receivement_gateways.paypal.identifier
                        }
                    }
                });
            }

            //UPline receber via Pagseguro
            if(this.isFirstPaymentUpLine && this.userFather.receivement_gateways.hasOwnProperty('pagseguro') && this.paymentMethodSelected == 'pagSeguro'){
                this.addDataNote({
                    recorrente: 0,
                    valor_desc_adic: this.product.amountFirstMonth,
                    nota: {
                        upline_first_payment: {
                            gateway: 'pagseguro',
                            identifier: this.userFather.receivement_gateways.pagseguro.identifier,
                            token: this.userFather.receivement_gateways.pagseguro.token
                        }
                    }
                });
            }
            
            await this.updateNoteInvoice();
        },
        addNoteVatFee(){
            if(this.product.currency == 'EUR'){
                let dataVatDetails = {
                    number_completed: this.vatFee.vatNumberCompleted,
                    number: this.vatFee.vatNumber,
                    country: this.vatFee.vatCountry,
                    fee: this.vatFee.percentage
                };
                
                //Remove todos os valor nulls
                this.addDataNote({
                    nota: {
                        vat_details: Object.fromEntries(Object.entries(dataVatDetails).filter(([key, value]) => value))
                    }
                });
            }
        },
        nextStepWithEmit(){
            this.$emit('step-emit', 'paymentConfirmation');
            this.nextStep();
        },
        prevStepWithEmit(){
            this.$emit('step-emit', 'planOrFee');
            this.prevStep();
        }
    },
    components: {
        Box,
        VueTelInput
    }
}
</script>

<style lang="scss">
    @import "../scss/mixins";
    .mandatory{
        display: flex;
        flex-wrap: wrap;

        & .at-input,
        & .vue-tel-input,
        & .at-select{
            flex: 1;
            min-width: 0;
        }

        &>span:not(.field-error){
            margin-left: 3px;
            margin-top: -4px;
            color: #d73a3a;
            flex-shrink: 0;
        }
    }

    .field-error{
        flex-basis: 100%;
        color: #FF4949;
        font-size: 10px;
        margin-top: -19px;
        margin-left: 3px;
        text-align: left;
    }

    .vue-tel-input ~ .field-error{
        margin-top: -2px;
    }

    #stripe-element{
        background: #efefef;
        padding: 15px;
        border-radius: 5px;
    }

    #stripe-wallets{
        width: 80%;
        margin: auto;
    }

    .payment{
        margin-top: 25px;

        @media (max-width: 767px){
            margin-top: 0;
        }
    }

    .paymentSecure_title{
        font-size: 0.9em;
        color: var(--gray);
        font-weight: 600;
    }

    .paymentSecure{
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin-bottom: 25px;
    }

    .paymentSecure_stamps{
        display: flex;
        font-size: 0.7em;
    }

    .paymentSecure_stamps_item{
        display: flex;
        margin-right: 20px;
    }
    .paymentSecure_stamps_item_icon{
        font-size: 1.3em;
        color: var(--blue);
    }

    .payment_paymentMethods_item_content_title{
        margin-bottom: 25px;

        & p:nth-of-type(1){
            font-size: 0.9em;
            font-weight: 600;
        }

        & p:nth-of-type(2){
            font-size: 0.7em;
            font-weight: 300;
        }
    }

    .payment_paymentMethods_item_contentBankTransfer,
    .payment_paymentMethods_item_contentNequi,
    .payment_paymentMethods_item_contentBoleto{
        & .vue-tel-input{
            padding: 0px;
        }
    }

    .payment_paymentMethods_item{
        display: flex;
        flex-direction: column;
        border: 2px solid #E9E9E9;
        border-radius: 4px;
        margin-bottom: 15px;
        padding: 20px;

        &:last-child{
            margin-bottom: 0px;
        }
    }
    .payment_paymentMethods_item_title{
        font-size: 0.8em;
        font-weight: 600;
        margin-bottom: 15px;
    }
    .payment_paymentMethods_item_menu{
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    .payment_paymentMethods_item_menu_data{
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    .payment_paymentMethods_item_menu_data_symbol{
        position: relative;
        width: 12px;
        height: 12px;
        border: 1px solid #8A8B8D;
        border-radius: 50%;
        margin-right: 10px;
    }
    .payment_paymentMethods_item_menu_data_img{
        width: 20px;
        margin-right: 8px;
    }
    .payment_paymentMethods_item_menu_data_name{
        font-size: 0.9em;
        font-weight: 600;
    }
    .payment_paymentMethods_item_menu_info{
        width: 265px;
        font-size: 0.6em;
        font-weight: 300;
        margin-left: 12px;
        padding-left: 12px;
        border-left: 1px solid var(--gray);
    }

    .payment_paymentMethods_item_content{
        margin-top: 20px;

        & .at-input__original{
            font-size: 12px;
            padding: 8px !important;

            &::placeholder{
                font-size: 12px;
            }
        }
    }

    .paymentMethodsActive{
        & .payment_paymentMethods_item_menu_data_symbol{
            border: none;
        }

        & .payment_paymentMethods_item_menu_data_symbol_ball{
            display: block;
            width: 10px;
            height: 10px;
            background: var(--blue);
            border-radius: 50px;
        }
    }

    .payment_paymentMethods_itemCreditCard{
        & .payment_paymentMethods_item_content{
            display: flex;
            flex-direction: column;
        }
    }
    .payment_paymentMethods_itemCreditCard_brands{
        display: flex;
        margin: auto;
        margin-top: 25px;
        align-items: center;
        justify-content: center;
        border: 1px solid #DCDCDC;
        padding: 10px 20px;
        border-radius: 5px;
    }
    .payment_paymentMethods_itemCreditCard_brands_image{
        width: 40px;
        margin-right: 20px;
    }

    .payment_paymentMethods_itemPaypal,
    .payment_paymentMethods_itemPagseguro,
    .payment_paymentMethods_itemPix{
        & .payment_paymentMethods_item_menu_data img{
            width: 16px;
        }

        & .payment_paymentMethods_item_content{
            font-size: 0.9em;
            text-align: center;
        }
    }
    .payment_paymentMethods_itemWallet{
        margin-bottom: 20px;
        text-align: center;
    }

    .payment_paymentMethods_itemMyCards{

        & .payment_paymentMethods_item_content{
            margin-top: 45px;
            margin-left: 23px;
        }

        & .payment_paymentMethods_item_menu_data_img{
            width: 25px;
        }
    }

    .payment_paymentMethods_item_myCards{
        position: relative;
        display: inline-block;
        cursor: pointer;
        border: 2px solid #e9e9e9;
        padding: 5px 10px;
        border-radius: 2px;
        margin-bottom: 30px;
        opacity: 0.7;
        transition: all 0.3s;

        &:last-child{
            margin-bottom: 0px;
        }
    }
    .payment_paymentMethods_item_myCards_check{
        width: 38px;
        height: 38px;
        background: #d7d7d7;
        margin-right: 17px;
        border-radius: 3px;
        transition: all 0.3s;
    }
    .payment_paymentMethods_item_myCards_separete{
        display: flex;
        align-items: center;
    }
    .payment_paymentMethods_item_myCards_brand{
        width: 40px;
    }
    .payment_paymentMethods_item_myCards_number{
        margin-left: 20px;
        letter-spacing: 3px;
        font-weight: bold;
    }
    .payment_paymentMethods_item_myCards_validate{
        position: absolute;
        top: -17px;
        right: 1px;
        font-size: 0.6em;
        font-weight: bold;
    }

    .payment_paymentMethods_item_myCardsActive{
        border-color: #1d9960;
        opacity: 1;

        & .payment_paymentMethods_item_myCards_check{
            border-radius: 50%;
            background: #1d9960;
        }
    }
    .payment_actions{
        margin-top: 25px;

        .at-btn:disabled{
            background-color: #b0b0b0 !important;
            border-color: #b0b0b0 !important;
            color: #ffffff !important;
            cursor: not-allowed;
            pointer-events: none;
        }
    }

    .payment_actions_devModePaymentConfirmation{
        margin-top: 10px !important;
        font-size: 0.7em !important;
        background: #718518 !important;
    }

    @include media(sm,md,lg){
        .payment_paymentMethods_item_menu{
            display: block;
        }

        .payment_actions{
            position: fixed;
            bottom: 0px;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            margin-bottom: 10px;
        }
    }
</style>
<style lang="css" scoped>
    .vue-tel-input {
        height: 38px;
    }
</style>